(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel"] && !Shopify.designMode) return;
  try {
    // blocks/_carousel.liquid
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.block_carousel').forEach(container => {
			new CustomCarousel(container);
		});

		window.requestAnimationFrame(() => {
			setTimeout(() => {
				window.dispatchEvent(new Event('active_animate'));
			}, 0);
		});
	});

	class CustomCarousel {

		constructor(container) {
			this.container = container;
			this.content = container.querySelector('.carousel_content');
			this.items = Array.from(this.content.children);
			this.scrollButtons = container.querySelectorAll('.carousel_nav_arrow');
			this.autoplayInterval = container.dataset.interval ? 1000 * parseFloat(container.dataset.interval) : null;
			this.currentScrollIndex = 0;
			this.observer = null;
			this.autoplayTimer = null;
			this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			this.hasUserInteracted = false;
			this.initAnimation();
			this.updateNavigationVisibility();
			this.setupEventListeners();
			this.setupIntersectionObserver();
			this.container.style.overflowY = 'hidden';
		}

		initAnimation() {
			const animatedItems = this.content.querySelectorAll('.animate');

			if (animatedItems.length > 0) {
				animatedItems.forEach(item => {
					item.classList.add('prevent_animate');
				});

				requestAnimationFrame(() => {
					this.content.classList.remove('prevent_animate');
				});
			}
		}

		getVisibleColumns() {
			const style = getComputedStyle(this.container);
			const mobileColumns = parseFloat(style.getPropertyValue('--mobile_columns')) || 1;
			const desktopColumns = parseFloat(style.getPropertyValue('--desktop_columns')) || mobileColumns;
			return this.container.offsetWidth > 767 ? desktopColumns : mobileColumns;
		}

		updateNavigationVisibility() {
			const itemCount = this.items.length;
			const visibleColumns = Math.ceil(this.getVisibleColumns());

			if (itemCount > visibleColumns) {
				this.container.classList.remove('navigation_disabled');
			} else {
				this.container.classList.add('navigation_disabled');
			}
		}

		stopAutoplayAndMarkInteraction() {
			this.hasUserInteracted = true;
			this.stopAutoplay();
		}

		scrollToIndex(index) {
			if (!this.items[index]) {
				return;
			}

			this.currentScrollIndex = index;

			const item = this.items[index];
			const scrollLeft = item.offsetLeft - this.content.offsetLeft;
			const behavior = this.container.classList.contains('smooth_scroll') ? 'smooth' : 'auto';

			this.content.scrollTo({ left: scrollLeft, behavior });
		}

		scrollBatch(direction) {
			if (this.container.classList.contains('navigation_disabled')) {
				return;
			}

			this.stopAutoplayAndMarkInteraction();

			const scrollLeft = this.content.scrollLeft;

			if (direction === 1) {
				const viewportRight = this.content.scrollLeft + this.content.clientWidth - 1;
				let nextIndex = -1;

				for (let i = 0; i < this.items.length; i++) {
					if (this.items[i].offsetLeft > viewportRight) {
						nextIndex = i;
						break;
					}
				}

				if (nextIndex === -1) {
					this.currentScrollIndex = 0;
					this.scrollToIndex(0);
					return;
				}

				this.currentScrollIndex = nextIndex;
			} else if (direction === -1) {
				if (scrollLeft <= 5) {
					this.currentScrollIndex = this.items.length - 1;
					this.scrollToIndex(this.currentScrollIndex);
					return;
				}

				let prevIndex = -1;
				const currentScrollLeft = this.content.scrollLeft;

				for (let i = this.items.length - 1; i >= 0; i--) {
					if (this.items[i].offsetLeft < currentScrollLeft - 5) {
						prevIndex = i;
						break;
					}
				}

				this.currentScrollIndex = prevIndex;
				this.scrollToIndex(this.currentScrollIndex);
			}

			this.scrollToIndex(this.currentScrollIndex);
		}

		scrollSingle(direction) {
			if (this.container.classList.contains('navigation_disabled')) {
				return;
			}

			this.stopAutoplayAndMarkInteraction();

			const itemCount = this.items.length;
			const lastIndex = Math.max(0, itemCount - 1);
			let newIndex = this.currentScrollIndex + direction;

			if (direction === -1) {
				if (this.currentScrollIndex === 0) {
					newIndex = lastIndex;
				} else if (newIndex < 0) {
					newIndex = 0;
				}
			} else if (direction === 1) {
				if (this.currentScrollIndex === lastIndex) {
					newIndex = 0;
				} else if (newIndex > lastIndex) {
					newIndex = lastIndex;
				}
			}

			this.currentScrollIndex = Math.max(0, newIndex);
			this.scrollToIndex(this.currentScrollIndex);
		}

		autoScroll() {
			if (!this.autoplayInterval || this.autoplayTimer || this.container.classList.contains('navigation_disabled') || this.prefersReducedMotion || this.hasUserInteracted) {
				return;
			}

			const itemCount = this.items.length;
			const firstItem = this.items[0];

			if (!firstItem) {
				return;
			}

			const gapValue = getComputedStyle(this.content).gap;
			const gap = parseFloat(gapValue.split(' ')[0]) || 0;
			const behavior = this.container.classList.contains('smooth_scroll') ? 'smooth' : 'auto';

			this.autoplayTimer = setInterval(() => {
				const nextIndex = this.currentScrollIndex + 1;

				if (nextIndex >= itemCount) {
					this.content.scrollTo({ left: 0, behavior: 'auto' });
					this.stopAutoplay();
					this.currentScrollIndex = 0;
					setTimeout(() => {
						this.autoScroll();
					}, 1);
					return;
				}

				const nextItem = this.items[nextIndex];

				if (!nextItem) {
					return;
				}

				const scrollAmount = nextItem.offsetWidth + gap;
				this.content.scrollBy({ left: scrollAmount, behavior });
				this.currentScrollIndex = nextIndex;
			}, this.autoplayInterval);
		}

		stopAutoplay() {
			if (this.autoplayTimer) {
				clearInterval(this.autoplayTimer);
				this.autoplayTimer = null;
			}
		}

		handleKeyDown(event) {
			if (this.container.classList.contains('navigation_disabled')) {
				return;
			}

			let direction = 0;

			if (event.key === 'ArrowLeft') {
				direction = -1;
			} else if (event.key === 'ArrowRight') {
				direction = 1;
			}

			if (direction !== 0) {
				event.preventDefault();
				this.scrollBatch(direction);
			}
		}

		setupIntersectionObserver() {
			this.observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					const item = entry.target;
					const animatedEl = item.querySelector('.animate') || item;

					if (entry.isIntersecting) {
						if (animatedEl.classList.contains('prevent_animate')) {
							animatedEl.classList.remove('prevent_animate');
							window.dispatchEvent(new Event('active_animate'));
						}

						item.querySelectorAll('video[autoplay]').forEach(video => video.play().catch(() => {}));
					} else {
						if (animatedEl.classList.contains('animate')) {
							animatedEl.classList.add('prevent_animate');
							window.dispatchEvent(new Event('active_animate'));
						}

						item.querySelectorAll('video').forEach(video => video.pause());
					}
				});
			}, { root: this.content, threshold: 0.5 });

			this.items.forEach(item => {
				this.observer.observe(item);
			});
		}

		setupEventListeners() {
			this.container.addEventListener('mouseenter', () => this.container.classList.add('is-hovering'));
			this.container.addEventListener('mouseleave', () => this.container.classList.remove('is-hovering'));

			this.scrollButtons.forEach(button => {
				button.addEventListener('click', event => {
					event.preventDefault();

					if (this.container.classList.contains('navigation_disabled')) {
						return;
					}

					const direction = parseInt(button.dataset.direction, 10);
					this.scrollBatch(direction);
				});
			});

			this.container.addEventListener('keydown', event => this.handleKeyDown(event));
			window.addEventListener('resize', () => this.updateNavigationVisibility());

			if (this.autoplayInterval) {
				this.autoScroll();

				if (this.container.dataset.pauseOnHover === 'true') {
					this.content.addEventListener('mouseenter', () => this.stopAutoplay());
					this.content.addEventListener('focusin', () => this.stopAutoplay());
					this.content.addEventListener('mouseleave', () => {
						if (!this.hasUserInteracted) {
							this.autoScroll();
						}
					});
					this.content.addEventListener('focusout', () => {
						if (!this.hasUserInteracted) {
							this.autoScroll();
						}
					});
				}
			}

			document.addEventListener('mediaSelected', event => {
				const mediaId = event.detail.mediaId;
				const productId = event.detail.productId;
				const containerProductId = this.container.dataset.productId ? parseInt(this.container.dataset.productId) : null;

				if (event.detail.originalEvent) {
					const originatingItem = event.detail.originalEvent.target.closest('.block_product_media');

					if (this.items.includes(originatingItem)) {
						return;
					}
				}

				if (!mediaId || (containerProductId !== null && containerProductId !== productId)) {
					return;
				}

				this.items.forEach((item, index) => {
					if (parseInt(item.dataset.mediaId) === mediaId) {
						setTimeout(() => this.scrollToIndex(index), 0);
						this.stopAutoplayAndMarkInteraction();
					}
				});
			});
		}
	}

	window.CustomCarousel = CustomCarousel;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_cart"] && !Shopify.designMode) return;
  try {
    // blocks/_cart.liquid
	let lastCartUpdatePromise = Promise.resolve();

	async function submitAndRefresh(url, method = 'GET', body) {
		lastCartUpdatePromise = lastCartUpdatePromise.then(async () => {
			let target = url;
			const options = { method };

			if (method === 'POST') {
				target = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
					? window.Shopify.routes.root + 'cart/update.js'
					: '/cart/update.js';
				options.body = body;
			}

			try {
				const response = await fetch(target, options);

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status} from ${target}`);
				}

				document.dispatchEvent(new CustomEvent('cartUpdate'));

				if (method === 'POST') {
					response.json().catch(error => {
						console.warn('Could not parse cart update JSON:', error);
					});
				}
			} catch (error) {
				console.error('Cart update failed:', error);
				throw error;
			}
		});
	}

	// atob() alone treats its input as Latin-1 (one byte per char code), so a
	// property value with non-ASCII text (accented names, etc.) decodes into
	// mojibake without this extra step — TextDecoder turns the raw bytes back
	// into a proper UTF-8 string, matching whatever encoded the payload.
	function base64UrlDecode(value) {
		const binary = atob(value.replace(/-/g, '+').replace(/_/g, '/'));
		const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));

		return new TextDecoder().decode(bytes);
	}

	// Handles a cart-add handoff from a surface that can't reach cart/add.js
	// itself (the Rack Group app's customer-account Lists page, which runs in
	// a sandboxed cross-origin extension with no access to the shopper's real
	// storefront cart session) — it instead navigates the shopper's browser
	// here with ?rackgrp_add=<base64url-encoded JSON>, an array of
	// {id, quantity, properties, bundle} entries shaped exactly like
	// blocks/_product-purchase-atc.liquid's own currentCustomData() output
	// (bundle holds already-bracket-indexed items[N][...] field names, so a
	// customized/bundled product's lines replay verbatim, no HMAC
	// re-signing needed here — that already happened server-side when the
	// product page rendered those hidden inputs). Items are added one at a
	// time, awaited in sequence rather than concurrently — see this file's
	// neighbor blocks/ai-chat.liquid's flushCartAdds, which documents a
	// confirmed cart/add.js race where concurrent requests only land the
	// first item.
	async function processIncomingCartAdd() {
		const params = new URLSearchParams(window.location.search);
		const payload = params.get('rackgrp_add');

		if (!payload) {
			return;
		}

		let items;

		try {
			items = JSON.parse(base64UrlDecode(payload));
		} catch (error) {
			console.error('Could not parse rackgrp_add payload:', error);
			return;
		}

		if (!Array.isArray(items) || !items.length) {
			return;
		}

		const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

		for (const item of items) {
			const formData = new FormData();
			formData.append('id', item.id);
			formData.append('quantity', item.quantity || 1);

			for (const [key, value] of Object.entries(item.properties || {})) {
				if (Array.isArray(value)) {
					for (const arrayValue of value) {
						formData.append(`properties[${key}][]`, arrayValue);
					}
				} else {
					formData.append(`properties[${key}]`, value);
				}
			}

			for (const [key, value] of Object.entries(item.bundle || {})) {
				formData.append(key, value);
			}

			try {
				const response = await fetch(cartRoot + 'cart/add.js', {
					method: 'POST',
					body: formData,
				});

				if (!response.ok) {
					const errorBody = await response.json().catch(() => null);

					throw new Error((errorBody && errorBody.description) || `HTTP error! status: ${response.status}`);
				}
			} catch (error) {
				console.error('rackgrp_add: could not add item', item, error);
			}
		}

		document.dispatchEvent(new CustomEvent('cartUpdate'));

		params.delete('rackgrp_add');
		const cleanedSearch = params.toString();
		const cleanedUrl = window.location.pathname + (cleanedSearch ? `?${cleanedSearch}` : '') + window.location.hash;
		window.history.replaceState({}, '', cleanedUrl);
	}

	function updateQtyButtons(container) {
		const input = container.querySelector('.qty_input');

		if (!input) {
			return;
		}

		const increase = container.querySelector('.increase');
		const decrease = container.querySelector('.decrease');
		const value = parseInt(input.value);
		const max = parseInt(input.max);
		const min = parseInt(input.min) || 1;

		decrease.disabled = value <= min;
		increase.disabled = value >= max;
	}

	document.addEventListener('cartUpdate', async () => {
		const cartBlocks = document.querySelectorAll('.block_cart');
		const currentUrl = window.location.href;
		const cartConditions = document.querySelectorAll('.cart_condition');

		await Promise.all(Array.from(cartBlocks).map(async block => {
			const blockId = block.id;
			const loader = block.querySelector('.loader_container');

			if (loader) {
				loader.style.display = 'block';
			}

			try {
				const response = await fetch(currentUrl);

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				const html = await response.text();
				const newBlock = new DOMParser().parseFromString(html, 'text/html').getElementById(blockId);

				if (newBlock) {
					block.replaceWith(newBlock);
				} else {
					console.warn(`Could not find a new main cart element with ID: ${blockId}. Element likely missing from fetched HTML.`);
				}

				if (loader) {
					loader.style.display = 'none';
				}
			} catch (error) {
				console.error('Error fetching or updating main cart block:', error);

				if (loader) {
					loader.style.display = 'none';
				}
			}
		}));

		const conditionIds = new Set();
		cartConditions.forEach(condition => {
			if (condition.id) {
				conditionIds.add(condition.id);
			}
		});

		try {
			const response = await fetch(currentUrl);

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const html = await response.text();
			const doc = new DOMParser().parseFromString(html, 'text/html');

			await Promise.all(Array.from(conditionIds).map(async id => {
				const liveElement = document.getElementById(id);
				const newElement = doc.getElementById(id);

				if (liveElement && newElement) {
					liveElement.replaceWith(newElement);
				}
			}));

			window.dispatchEvent(new CustomEvent('active_animate'));
		} catch (error) {
			console.error('Error fetching or updating conditional blocks:', error);
		}
	});

	document.addEventListener('click', e => {
		const target = e.target;
		const cartBlock = target.closest('.block_cart');

		if (!cartBlock) {
			return;
		}

		if (target.classList.contains('increase') || target.classList.contains('decrease')) {
			e.preventDefault();

			const container = target.closest('.qty_input_container');
			const input = container ? container.querySelector('.qty_input') : null;
			const form = input ? input.closest('form') : null;

			if (!input || !form) {
				return;
			}

			const value = parseInt(input.value);
			input.value = target.classList.contains('increase') ? value + 1 : value - 1;
			input.dispatchEvent(new Event('input', { bubbles: true }));
		} else if (target.closest('a.remove_link')) {
			const removeLink = target.closest('a.remove_link');
			e.preventDefault();
			submitAndRefresh(removeLink.href, 'GET');
		}
	});

	document.addEventListener('input', e => {
		const target = e.target;

		if (target.classList.contains('qty_input') && target.closest('.block_cart')) {
			const container = target.closest('.qty_input_container');
			const form = target.closest('form');

			if (!container || !form) {
				return;
			}

			if (target.value < parseInt(target.min) || !target.value) {
				target.value = parseInt(target.min) || 1;
			}

			updateQtyButtons(container);
			const formData = new FormData(form);
			submitAndRefresh(null, 'POST', formData);
		}
	});

	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.block_cart .qty_input_container').forEach(updateQtyButtons);
		processIncomingCartAdd();
	});

	document.addEventListener('cartUpdate', () => {
		document.querySelectorAll('.block_cart .qty_input_container').forEach(updateQtyButtons);
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_hero"] && !Shopify.designMode) return;
  try {
    // blocks/_hero.liquid
function HeroSlideshow(heroContainer) {
	const slides = heroContainer.querySelectorAll(':scope > .block_hero_slide');
	const prevArrow = heroContainer.querySelector('.hero_nav_arrow.prev');
	const nextArrow = heroContainer.querySelector('.hero_nav_arrow.next');
	const dotsContainer = heroContainer.querySelector('.hero_nav_dots');
	const indicatorBar = heroContainer.querySelector('.hero_slide_indicator_bar');
	const hideDelay = 1000;

	let currentIndex = 0;
	let autoplayTimer = null;
	let hideTimer = null;
	let isPaused = false;
	let isTransitioning = false;
	let touchStartX = 0;

	const swipeThreshold = 50;

	if (!slides[currentIndex].classList.contains('active')) {
		slides[currentIndex].classList.add('active');
	}

	slides.forEach((slide, index) => {
		if (index !== currentIndex) {
			slide.classList.add('prevent_animate');
		}
	});

	function revealLazyImages(slide) {
		if (!slide) {
			return;
		}

		slide.querySelectorAll('img[data-src]').forEach(img => {
			const dataSrc = img.getAttribute('data-src');
			const dataSrcset = img.getAttribute('data-srcset');

			if (dataSrc) {
				img.setAttribute('src', dataSrc);
				img.removeAttribute('data-src');
			}

			if (dataSrcset) {
				img.setAttribute('srcset', dataSrcset);
				img.removeAttribute('data-srcset');
			}
		});
	}

	function pauseAndResetVideo(slide) {
		if (!slide) {
			return;
		}

		const video = slide.querySelector('video');

		if (video) {
			try {
				video.pause();

				if (video.currentTime > 0) {
					video.currentTime = 0;
				}
			} catch (error) {}
		}
	}

	function cleanupPendingTransition() {
		if (hideTimer) {
			clearTimeout(hideTimer);
			hideTimer = null;
			return;
		}

		if (indicatorBar) {
			for (const wrap of indicatorBar.querySelectorAll('.indicator_wrap.is_animating')) {
				wrap.classList.remove('is_animating');
			}
		}

		for (const slide of heroContainer.querySelectorAll('.block_hero_slide.hidden')) {
			slide.classList.remove('hidden');
			slide.style.display = 'none';
			slide.style.opacity = '0';
			pauseAndResetVideo(slide);
		}

		isTransitioning = false;
	}

	function playVideo(slide) {
		if (!slide) {
			return;
		}

		const video = slide.querySelector('video');

		if (video) {
			video.play().catch(() => {});
		}
	}

	function updateFocusability() {
		const focusableSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), video';

		slides.forEach((slide, index) => {
			const isActive = index === currentIndex;
			slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

			const focusableElements = slide.querySelectorAll(focusableSelector);

			focusableElements.forEach(el => {
				if (isActive) {
					if (el.dataset.originalTabindex) {
						el.setAttribute('tabindex', el.dataset.originalTabindex);
						el.removeAttribute('data-original-tabindex');
					} else {
						el.removeAttribute('tabindex');
					}
				} else {
					if (el.hasAttribute('tabindex')) {
						el.dataset.originalTabindex = el.getAttribute('tabindex');
					}

					el.setAttribute('tabindex', '-1');
				}
			});
		});
	}

	function goToSlide(newIndex) {
		clearTimeout(autoplayTimer);
		autoplayTimer = null;

		if (indicatorBar) {
			for (const wrap of indicatorBar.querySelectorAll('.indicator_wrap')) {
				wrap.classList.remove('is_animating');
			}
		}

		if (indicatorBar) {
			for (const bar of indicatorBar.querySelectorAll('.indicator_bar')) {
				bar.style.transition = 'none';
				bar.style.width = '0%';
			}
		}

		cleanupPendingTransition();
		isTransitioning = true;

		const oldIndex = currentIndex;
		currentIndex = newIndex;

		const newSlide = slides[currentIndex];
		const oldSlide = slides[oldIndex];

		oldSlide.classList.add('prevent_animate');
		newSlide.classList.remove('prevent_animate');
		revealLazyImages(newSlide);
		oldSlide.classList.add('hidden');
		oldSlide.classList.remove('active');
		newSlide.style.display = 'block';
		newSlide.classList.add('active');
		newSlide.classList.remove('hidden');
		playVideo(newSlide);
		updateActiveIndicators();
		updateFocusability();
		window.dispatchEvent(new Event('active_animate'));

		setTimeout(() => {
			restartAutoplay();
		}, 10);

		hideTimer = setTimeout(() => {
			oldSlide.classList.remove('hidden');
			isTransitioning = false;
			hideTimer = null;
			pauseAndResetVideo(oldSlide);
		}, hideDelay);
	}

	function goToSlideWrapped(index) {
		const wrappedIndex = (index + slides.length) % slides.length;

		if (wrappedIndex !== currentIndex) {
			goToSlide(wrappedIndex);
		}
	}

	function goToNext() {
		goToSlideWrapped(currentIndex + 1);
	}

	function goToPrev() {
		goToSlideWrapped(currentIndex - 1);
	}

	function scheduleAutoplay() {
		if (!heroContainer.hasAttribute('data-interval')) {
			return;
		}

		if (!autoplayTimer && !isPaused) {
			autoplayTimer = setTimeout(goToNext, interval);
			setProgressAnimating(true);
		}
	}

	function cancelAutoplay() {
		clearTimeout(autoplayTimer);
		autoplayTimer = null;
		setProgressAnimating(false);
	}

	function restartAutoplay() {
		cancelAutoplay();
		scheduleAutoplay();
	}

	function buildNavControls() {
		slides.forEach((slide, index) => {
			const preloadSlide = () => {
				const targetSlide = slides[index];

				if (index !== currentIndex) {
					revealLazyImages(targetSlide);
				}
			};

			if (dotsContainer) {
				const dot = document.createElement('span');
				dot.classList.add('hero_dot');
				dot.dataset.slideIndex = index;
				dot.setAttribute('tabindex', '0');
				dot.addEventListener('click', () => {
					goToSlideWrapped(index);
				});
				dot.addEventListener('mouseenter', preloadSlide);
				dotsContainer.appendChild(dot);
			}

			if (indicatorBar) {
				const indicatorWrap = document.createElement('div');
				indicatorWrap.classList.add('indicator_wrap');
				indicatorWrap.dataset.slideIndex = index;
				indicatorWrap.setAttribute('tabindex', '0');

				const indicatorFill = document.createElement('div');
				indicatorFill.classList.add('indicator_bar');
				indicatorWrap.appendChild(indicatorFill);
				indicatorWrap.addEventListener('click', () => {
					goToSlideWrapped(index);
				});
				indicatorWrap.addEventListener('mouseenter', preloadSlide);
				indicatorBar.appendChild(indicatorWrap);
			}
		});
	}

	function updateActiveIndicators() {
		if (dotsContainer) {
			for (const dot of dotsContainer.querySelectorAll('.hero_dot')) {
				dot.classList.toggle('active', parseInt(dot.dataset.slideIndex) === currentIndex);
			}
		}

		if (indicatorBar) {
			for (const wrap of indicatorBar.querySelectorAll('.indicator_wrap')) {
				wrap.classList.toggle('active', parseInt(wrap.dataset.slideIndex) === currentIndex);
			}
		}
	}

	function setProgressAnimating(shouldAnimate) {
		if (!indicatorBar) {
			return;
		}

		let activeIndicator = indicatorBar.querySelector('.indicator_wrap.active');

		if (!activeIndicator) {
			const matchingIndicator = indicatorBar.querySelector(`.indicator_wrap[data-slide-index="${currentIndex}"]`);

			if (!matchingIndicator) {
				return;
			}

			matchingIndicator.classList.add('active');
			activeIndicator = matchingIndicator;
		}

		for (const bar of indicatorBar.querySelectorAll('.indicator_bar')) {
			bar.style.transition = 'none';
			bar.style.width = '0%';
		}

		if (shouldAnimate && !isPaused) {
			activeIndicator.classList.remove('is_animating');
			activeIndicator.style.setProperty('--progress-duration', `${interval}ms`);
			activeIndicator.offsetWidth;
			setTimeout(() => {
				activeIndicator.classList.add('is_animating');
			}, 0);
		} else {
			activeIndicator.classList.remove('is_animating');
		}
	}

	function attachControls() {
		if (prevArrow) {
			prevArrow.style.display = '';
			prevArrow.setAttribute('tabindex', '0');
			prevArrow.addEventListener('click', goToPrev);
		}

		if (nextArrow) {
			nextArrow.style.display = '';
			nextArrow.setAttribute('tabindex', '0');
			nextArrow.addEventListener('click', goToNext);
		}

		if (pauseOnHover) {
			heroContainer.addEventListener('mouseenter', () => {
				isPaused = true;
				cancelAutoplay();
			});
			heroContainer.addEventListener('mouseleave', () => {
				isPaused = false;
				scheduleAutoplay();
			});
		}

		if (allowSwipe) {
			heroContainer.addEventListener('touchstart', event => {
				touchStartX = event.touches[0].clientX;
			});
			heroContainer.addEventListener('touchmove', event => {
				if (Math.abs(event.touches[0].clientX - touchStartX) > 10) {
					event.preventDefault();
				}
			}, { passive: false });
			heroContainer.addEventListener('touchend', event => {
				const touchEndX = event.changedTouches[0].clientX;
				const diff = touchEndX - touchStartX;

				if (Math.abs(diff) > swipeThreshold) {
					diff > 0 ? goToPrev() : goToNext();
				}
			});
		}

		document.addEventListener('keydown', event => {
			if (!heroContainer.contains(document.activeElement) || document.body.classList.contains('modal_open')) {
				return;
			}

			if (event.key === 'ArrowLeft') {
				goToPrev();
				event.preventDefault();
			} else if (event.key === 'ArrowRight') {
				goToNext();
				event.preventDefault();
			}

			const activeEl = document.activeElement;

			if (activeEl.classList.contains('hero_dot') || activeEl.classList.contains('indicator_wrap')) {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					goToSlideWrapped(parseInt(activeEl.dataset.slideIndex));
				}
			}
		});
	}

	const interval = parseInt(heroContainer.dataset.interval) || 5000;
	const pauseOnHover = heroContainer.dataset.pauseOnHover === 'true';
	const allowSwipe = heroContainer.dataset.allowSwipe === 'true';

	revealLazyImages(slides[currentIndex]);
	playVideo(slides[currentIndex]);

	if (slides.length <= 1) {
		if (prevArrow) {
			prevArrow.style.display = 'none';
		}

		if (nextArrow) {
			nextArrow.style.display = 'none';
		}

		if (dotsContainer) {
			dotsContainer.style.display = 'none';
		}

		if (indicatorBar) {
			indicatorBar.style.display = 'none';
		}

		return;
	}

	buildNavControls();
	updateActiveIndicators();
	updateFocusability();
	attachControls();
	scheduleAutoplay();

	window.requestAnimationFrame(() => {
		slides[currentIndex].offsetWidth;
		setTimeout(() => {
			window.dispatchEvent(new Event('active_animate'));
		}, 0);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.block_hero').forEach(heroContainer => {
		HeroSlideshow(heroContainer);
	});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-purchase-atc"] && !Shopify.designMode) return;
  try {
    // blocks/_product-purchase-atc.liquid
document.addEventListener('DOMContentLoaded', () => {
	const atcBlocks = document.querySelectorAll('.block_product_purchase_atc');

	function setupAtc(atc) {
		const form = atc.closest('form');

		if (!form) {
			return;
		}

		const qtyInput = atc.querySelector('.qty_input');
		const decreaseBtn = atc.querySelector('.btn.decrease');
		const increaseBtn = atc.querySelector('.btn.increase');
		const submitBtn = atc.querySelector('button[type="submit"]');
		const qtyContainer = atc.querySelector('.qty_input_container');
		const submitBtnSpan = submitBtn ? submitBtn.querySelector('span') : null;
		const oosText = submitBtn ? submitBtn.getAttribute('data-oos') : '';
		const defaultBtnText = submitBtnSpan ? submitBtnSpan.textContent : '';

		function updateState() {
			const quantityAttr = atc.getAttribute('data-quantity');
			const buildAvailable = atc.getAttribute('data-build-available');
			const availableQty = quantityAttr !== 'false' && quantityAttr !== null && quantityAttr !== '' ? parseInt(quantityAttr) : '';
			const isSoldOut = quantityAttr === '0' || buildAvailable === 'false';
			const isDisabled = availableQty === 1 || isSoldOut;

			if (qtyInput) {
				qtyInput.setAttribute('max', availableQty);
				qtyInput.disabled = isDisabled;

				if (isDisabled) {
					qtyInput.value = 1;
				}
			}

			if (qtyInput) {
				const currentVal = parseInt(qtyInput.value);

				if (decreaseBtn) {
					decreaseBtn.disabled = currentVal <= 1;
				}

				if (increaseBtn) {
					increaseBtn.disabled = availableQty !== '' && currentVal >= availableQty;
				}
			}

			if (submitBtn) {
				submitBtn.disabled = isSoldOut;

				if (submitBtnSpan) {
					submitBtnSpan.textContent = isSoldOut ? oosText : defaultBtnText;
				}
			}

			if (qtyContainer) {
				qtyContainer.style.display = isDisabled ? 'none' : '';
			}
		}

		function adjustQty(delta) {
			const currentVal = parseInt(qtyInput.value) || 1;
			const maxVal = qtyInput.getAttribute('max') !== '' ? parseInt(qtyInput.getAttribute('max')) : Infinity;
			const minVal = parseInt(qtyInput.getAttribute('min')) || 1;
			let newVal = currentVal + delta;
			newVal = Math.max(minVal, Math.min(newVal, maxVal));

			if (newVal !== currentVal) {
				qtyInput.value = newVal;
				updateState();
			}
		}

		form.addEventListener('submit', function handleSubmit(event) {
			event.preventDefault();

			const formData = new FormData(form);
			const returnTo = formData.get('return_to');
			const addToCartUrl = window.Shopify.routes.root + 'cart/add.js';

			submitBtn.disabled = true;
			atc.classList.add('adding');

			fetch(addToCartUrl, { method: 'POST', body: formData })
				.then(response => response.ok ? response.json() : response.json().then(errorBody => {
					throw Error(errorBody.description || `HTTP error! status: ${response.status}`);
				}).catch(() => {
					throw Error(`HTTP error! status: ${response.status}`);
				}))
				.then(() => {
					if (returnTo && returnTo.startsWith('#')) {
						atc.dispatchEvent(new CustomEvent('popSlide', { bubbles: true, detail: { id: returnTo } }));
						atc.dispatchEvent(new CustomEvent('cartUpdate', { bubbles: true }));
					} else if (returnTo) {
						window.location.href = returnTo;
					} else {
						atc.dispatchEvent(new CustomEvent('cartUpdate', { bubbles: true }));
					}
				})
				.catch(error => {
					console.error('Add to cart failed:', error.message);
				})
				.finally(() => {
					atc.classList.remove('adding');
					updateState();
				});
		});

		updateState();

		if (decreaseBtn) {
			decreaseBtn.addEventListener('click', event => {
				event.preventDefault();
				adjustQty(-1);
			});
		}

		if (increaseBtn) {
			increaseBtn.addEventListener('click', event => {
				event.preventDefault();
				adjustQty(1);
			});
		}

		if (qtyInput) {
			qtyInput.addEventListener('change', updateState);
		}

		document.addEventListener('variantSelected', function onVariantSelected(event) {
			const quantity = event.detail && event.detail.quantity !== undefined ? event.detail.quantity : 'false';
			atc.setAttribute('data-quantity', quantity);
			updateState();
		});

		document.addEventListener('bundleStatusUpdate', function onBundleStatusUpdate(event) {
			atc.setAttribute('data-build-available', String(event.detail.available));
			updateState();
		});

		setupWishlist(atc, form);
		setupWaitlist(atc, form);
	}

	function setupWishlist(atc, form) {
		const wrap = atc.querySelector('.product_purchase_atc__wishlist');

		if (!wrap) {
			return;
		}

		const heartBtn = wrap.querySelector('.product_purchase_atc__wishlist_btn');
		const isGuest = wrap.getAttribute('data-logged-in') !== 'true';
		const trackVariant = wrap.getAttribute('data-track-variant') === 'true';
		const allowMultiple = wrap.getAttribute('data-allow-multiple') === 'true';
		const productId = wrap.getAttribute('data-product-id');
		let variantId = wrap.getAttribute('data-variant-id') || null;

		// Guests get a plain login link with no fetch/click wiring — the App
		// Proxy has no identity to look anything up against for them.
		if (isGuest) {
			return;
		}

		let lists = [];
		let loaded = false;

		function matchesScope(item) {
			if (item.productId !== productId) {
				return false;
			}

			return trackVariant ? (item.variantId || null) === variantId : true;
		}

		function itemsMatchingCurrent() {
			const matches = [];

			for (const list of lists) {
				for (const item of list.items) {
					if (matchesScope(item)) {
						matches.push({ list, item });
					}
				}
			}

			return matches;
		}

		function renderHeart() {
			const icon = heartBtn.querySelector('i');
			const solid = itemsMatchingCurrent().length > 0;

			if (icon) {
				icon.classList.toggle('fa-solid', solid);
				icon.classList.toggle('fa-regular', !solid);
			}

			// Single-list mode: the button itself toggles membership, so
			// aria-pressed reflects that. Multi-list mode: the button only
			// opens/closes the checkbox panel (aria-expanded, set on click),
			// so it never gets aria-pressed too — the heart fill alone
			// conveys membership state there.
			if (!allowMultiple) {
				heartBtn.setAttribute('aria-pressed', String(solid));
			}
		}

		function renderPanel() {
			if (!allowMultiple) {
				return;
			}

			const panelList = wrap.querySelector('.product_purchase_atc__wishlist_list');

			if (!panelList) {
				return;
			}

			panelList.innerHTML = '';

			for (const list of lists) {
				const checked = list.items.some(matchesScope);
				const li = document.createElement('li');
				const label = document.createElement('label');
				const checkbox = document.createElement('input');

				checkbox.type = 'checkbox';
				checkbox.checked = checked;
				checkbox.dataset.listId = list.id;
				checkbox.addEventListener('change', onListCheckboxChange);

				label.appendChild(checkbox);
				label.appendChild(document.createTextNode(' ' + list.name));
				li.appendChild(label);
				panelList.appendChild(li);
			}
		}

		function setLoading(isLoading) {
			wrap.classList.toggle('is-loading', isLoading);

			for (const el of wrap.querySelectorAll('input, button')) {
				el.disabled = isLoading;
			}
		}

		function currentQuantity() {
			const qtyInput = form.querySelector('.qty_input');
			return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
		}

		function currentCustomData() {
			const formData = new FormData(form);
			const properties = {};

			// Bundle default/included lines submit their signed discount data as
			// repeatable array fields — properties[_defaults_value][], not a plain
			// properties[_defaults_value] — since more than one build option can be
			// "Included" at once (see snippets/build-builder-product-addon.liquid).
			// The previous regex here (`/^properties\[(.+)\]$/`, greedy) captured
			// "_defaults_value][" as the key for those instead of "_defaults_value",
			// and a plain assignment would also silently keep only the last of
			// several same-named values. Both are fixed here: a non-greedy capture
			// stops at the first `]`, and a trailing `[]` collects into an array.
			for (const [key, value] of formData.entries()) {
				const match = /^properties\[(.+?)\](\[\])?$/.exec(key);

				if (!match) {
					continue;
				}

				if (match[2]) {
					if (!Array.isArray(properties[match[1]])) {
						properties[match[1]] = [];
					}

					properties[match[1]].push(value);
				} else {
					properties[match[1]] = value;
				}
			}

			const customData = { properties };
			const bundle = {};

			// .addon_variant (an optional add-on's own variant selection) and
			// .bundle_id (the _in_bundle linking property every bundle line needs)
			// were both missing from this selector — neither is named
			// .bundle_variant/.bundle_qty, so a saved wishlist item for a
			// customized/bundled product was silently missing its add-on choice
			// and the id that ties its lines together as one bundle.
			for (const input of form.querySelectorAll('.bundle_variant, .bundle_qty, .addon_variant, .bundle_id')) {
				if (input.name) {
					bundle[input.name] = input.value;
				}
			}

			if (Object.keys(bundle).length) {
				customData.bundle = bundle;
			}

			return customData;
		}

		async function fetchLists() {
			const response = await fetch('/apps/storefront/lists');

			if (!response.ok) {
				throw new Error('Failed to load wishlists');
			}

			const data = await response.json();
			return data.lists || [];
		}

		async function addListItem(listId) {
			const response = await fetch('/apps/storefront/items', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					wishlistId: listId,
					productId,
					variantId: trackVariant ? variantId : null,
					quantityDesired: currentQuantity(),
					customData: currentCustomData(),
				}),
			});
			const data = await response.json();

			if (data.error) {
				throw new Error(data.error);
			}

			return data.item;
		}

		async function removeListItem(listId, itemId) {
			const response = await fetch('/apps/storefront/items', {
				method: 'DELETE',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ wishlistId: listId, itemId }),
			});
			const data = await response.json();

			if (data.error) {
				throw new Error(data.error);
			}
		}

		async function findOrCreateList(name) {
			const response = await fetch('/apps/storefront/lists', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ name, findOrCreate: true }),
			});
			const data = await response.json();

			if (data.error) {
				throw new Error(data.error);
			}

			return data.list;
		}

		// Deliberately a plain create, not findOrCreateList — a shopper
		// explicitly typing a new name here is expected to be able to create
		// duplicates, same as the existing Customer Account Lists extension.
		async function createList(name) {
			const response = await fetch('/apps/storefront/lists', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ name }),
			});
			const data = await response.json();

			if (data.error) {
				throw new Error(data.error);
			}

			return data.list;
		}

		async function refreshFromServer() {
			lists = await fetchLists();
			loaded = true;
			renderHeart();
			renderPanel();
		}

		async function loadState() {
			setLoading(true);

			try {
				await refreshFromServer();
			} catch (error) {
				console.error('Wishlist fetch failed:', error.message);
			} finally {
				setLoading(false);
			}
		}

		async function onListCheckboxChange(event) {
			const checkbox = event.target;
			const listId = Number(checkbox.dataset.listId);

			checkbox.disabled = true;

			try {
				if (checkbox.checked) {
					await addListItem(listId);
				} else {
					const list = lists.find(l => l.id === listId);
					const item = list ? list.items.find(matchesScope) : null;

					if (item) {
						await removeListItem(listId, item.id);
					}
				}

				await refreshFromServer();
			} catch (error) {
				console.error('Wishlist update failed:', error.message);
				checkbox.checked = !checkbox.checked;
			} finally {
				checkbox.disabled = false;
			}
		}

		heartBtn.addEventListener('click', async () => {
			if (allowMultiple) {
				const expanded = heartBtn.getAttribute('aria-expanded') === 'true';
				const panel = document.getElementById(heartBtn.getAttribute('aria-controls'));

				heartBtn.setAttribute('aria-expanded', String(!expanded));

				if (panel) {
					panel.hidden = expanded;
				}

				return;
			}

			setLoading(true);

			try {
				const matches = itemsMatchingCurrent();

				if (matches.length > 0) {
					await Promise.all(matches.map(({ list, item }) => removeListItem(list.id, item.id)));
				} else {
					const list = await findOrCreateList('My List');
					await addListItem(list.id);
				}

				await refreshFromServer();
			} catch (error) {
				console.error('Wishlist update failed:', error.message);
			} finally {
				setLoading(false);
			}
		});

		const createInput = wrap.querySelector('.product_purchase_atc__wishlist_create_input');
		const createOkBtn = wrap.querySelector('.product_purchase_atc__wishlist_create_ok');

		if (createOkBtn) {
			createOkBtn.addEventListener('click', async () => {
				const name = createInput.value.trim();

				if (!name) {
					return;
				}

				setLoading(true);

				try {
					const list = await createList(name);
					await addListItem(list.id);
					createInput.value = '';
					await refreshFromServer();
				} catch (error) {
					console.error('Create list failed:', error.message);
				} finally {
					setLoading(false);
				}
			});
		}

		document.addEventListener('variantSelected', event => {
			if (event.detail && event.detail.variantId !== undefined) {
				variantId = 'gid://shopify/ProductVariant/' + event.detail.variantId;
			}

			if (loaded) {
				renderHeart();
				renderPanel();
			}
		});

		loadState();
	}

	function setupWaitlist(atc, form) {
		const link = atc.querySelector('.product_purchase_atc__waitlist_link');

		if (!link) {
			return;
		}

		const isGuest = link.getAttribute('data-logged-in') !== 'true';
		const productId = link.getAttribute('data-product-id');
		let variantId = link.getAttribute('data-variant-id') || null;

		function isSoldOut() {
			return atc.getAttribute('data-quantity') === '0' || atc.getAttribute('data-build-available') === 'false';
		}

		function updateVisibility() {
			link.hidden = !isSoldOut();
		}

		updateVisibility();
		document.addEventListener('variantSelected', updateVisibility);
		document.addEventListener('bundleStatusUpdate', updateVisibility);

		// Guests get a plain login link — no fetch/click wiring, since the App
		// Proxy has no identity to look anything up against for them. Stock
		// visibility above still applies regardless of login state.
		if (isGuest) {
			return;
		}

		let lists = [];
		let loaded = false;

		function matches() {
			const found = [];

			for (const list of lists) {
				for (const item of list.items) {
					if (item.productId === productId && (item.variantId || null) === variantId && item.notifyBackInStock) {
						found.push({ list, item });
					}
				}
			}

			return found;
		}

		function renderText() {
			const active = matches().length > 0;

			link.textContent = active
				? link.getAttribute('data-waitlist-active-text')
				: link.getAttribute('data-waitlist-btn-text');
			link.dataset.active = String(active);
		}

		function setLoading(isLoading) {
			link.classList.toggle('is-loading', isLoading);
			link.setAttribute('aria-disabled', String(isLoading));
		}

		function currentQuantity() {
			const qtyInput = form.querySelector('.qty_input');
			return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
		}

		function currentCustomData() {
			const formData = new FormData(form);
			const properties = {};

			// Same fix as setupWishlist's currentCustomData above — see its comment
			// for why the non-greedy capture and the array branch are both needed.
			for (const [key, value] of formData.entries()) {
				const match = /^properties\[(.+?)\](\[\])?$/.exec(key);

				if (!match) {
					continue;
				}

				if (match[2]) {
					if (!Array.isArray(properties[match[1]])) {
						properties[match[1]] = [];
					}

					properties[match[1]].push(value);
				} else {
					properties[match[1]] = value;
				}
			}

			const customData = { properties };
			const bundle = {};

			// This copy was missing bundle capture entirely — a waitlisted
			// customized/bundled product would lose its selections outright. Same
			// selector as setupWishlist's version, for the same reason.
			for (const input of form.querySelectorAll('.bundle_variant, .bundle_qty, .addon_variant, .bundle_id')) {
				if (input.name) {
					bundle[input.name] = input.value;
				}
			}

			if (Object.keys(bundle).length) {
				customData.bundle = bundle;
			}

			return customData;
		}

		async function fetchLists() {
			const response = await fetch('/apps/storefront/lists');

			if (!response.ok) {
				throw new Error('Failed to load wishlists');
			}

			const data = await response.json();
			return data.lists || [];
		}

		async function addToWaitlist() {
			const createResponse = await fetch('/apps/storefront/lists', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ name: 'Waiting', findOrCreate: true }),
			});
			const createData = await createResponse.json();

			if (createData.error) {
				throw new Error(createData.error);
			}

			const response = await fetch('/apps/storefront/items', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					wishlistId: createData.list.id,
					productId,
					variantId,
					quantityDesired: currentQuantity(),
					customData: currentCustomData(),
					notifyBackInStock: true,
				}),
			});
			const data = await response.json();

			if (data.error) {
				throw new Error(data.error);
			}
		}

		async function loadState() {
			setLoading(true);

			try {
				lists = await fetchLists();
				loaded = true;
				renderText();
			} catch (error) {
				console.error('Waitlist fetch failed:', error.message);
			} finally {
				setLoading(false);
			}
		}

		document.addEventListener('variantSelected', event => {
			if (event.detail && event.detail.variantId !== undefined) {
				variantId = 'gid://shopify/ProductVariant/' + event.detail.variantId;
			}

			if (loaded) {
				renderText();
			}
		});

		link.addEventListener('click', event => {
			if (link.classList.contains('is-loading')) {
				event.preventDefault();
				return;
			}

			// Already waiting: the href already points at the Lists page, so
			// let the default navigation happen instead of calling the API.
			if (link.dataset.active === 'true') {
				return;
			}

			event.preventDefault();
			setLoading(true);

			addToWaitlist()
				.then(() => fetchLists())
				.then(freshLists => {
					lists = freshLists;
					renderText();
				})
				.catch(error => {
					console.error('Waitlist update failed:', error.message);
				})
				.finally(() => {
					setLoading(false);
				});
		});

		loadState();
	}

	atcBlocks.forEach(setupAtc);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-purchase-builder"] && !Shopify.designMode) return;
  try {
    // blocks/product-purchase-bundle.liquid
/**
 * Shopify Product Customizer / Bundle Builder
 * Handles multi-product selections, dynamic pricing tallies, 
 * URL state persistence (deep linking), and quantity synchronization.
 */
(function() {
	const BUILDER_SELECTOR = '.block_product_purchase_builder';
	let cartCurrency = 'USD';

	// Parse the 'build' parameter from the URL to restore a saved configuration
	const urlSearchParams = new URLSearchParams(window.location.search);
	const initialBuildData = urlSearchParams.get('build');
	let isInitializingState = !!initialBuildData;

	/**
	 * Fetches the current store currency from the Shopify cart API.
	 */
	const getCurrencyCode = async () => {
		try {
			const response = await fetch('/cart.js');
			const cartData = await response.json();
			cartCurrency = cartData.currency || 'USD';
		} catch (error) {
			cartCurrency = 'USD';
		}
	};

	/**
	 * Dispatches GA4 events if gtag is present on the window.
	 */
	const trackAnalyticsEvent = (eventName, eventParams) => {
		if (typeof gtag === 'function') {
			gtag('event', eventName, eventParams);
		}
	};

	/**
	 * Generates a unique ID to link the main product and its bundle components 
	 * in the Shopify cart via line item properties.
	 */
	const updateBundleGroupIDs = () => {
		document.querySelectorAll(BUILDER_SELECTOR).forEach(builder => {
			const uniqueBundleId = Date.now().toString() + Math.random().toString(36).substr(2, 5);
			builder.querySelectorAll('.bundle_id').forEach(input => {
				input.value = uniqueBundleId;
			});
		});
	};

	/**
	 * Serializes the current UI state into a shorthand string for the URL.
	 * Format: [Builder1]~[Builder2] where components are indexed for brevity.
	 */
	const updateURLState = () => {
		if (isInitializingState) return;

		const builders = document.querySelectorAll(BUILDER_SELECTOR);
		const allBuilderStates = [];

		builders.forEach(builder => {
			// Only update URL if the builder is configured for it and not currently rehydrating
			if (builder.getAttribute('data-url') !== 'true' || builder.hasAttribute('data-rehydrating')) {
				allBuilderStates.push('');
				return;
			}

			const rootUl = builder.querySelector(':scope > ul');
			if (!rootUl) {
				allBuilderStates.push('');
				return;
			}

			const builderSegments = [];

			rootUl.querySelectorAll(':scope > li').forEach(rootListItem => {
				let branchPath = [];

				const traverseDepth = (ul) => {
					if (!ul) return;

					// Find the active selection in this branch
					const activeLi = Array.from(ul.querySelectorAll(':scope > li')).find(li => 
						li.querySelector('.product_btn.active, .option_btn.active') || li.querySelector('.active')
					);

					if (!activeLi) return;

					const actionButton = activeLi.querySelector(':scope > .product_btn, :scope > .option_btn');
					const liIndex = Array.from(ul.children).indexOf(activeLi) + 1;
					let stateParts = [liIndex];

					// Capture active variant indices within fieldsets
					if (actionButton) {
						activeLi.querySelectorAll(':scope > .child_options > fieldset').forEach(fieldset => {
							const activeVariantBtn = fieldset.querySelector('.variant_btn.active');
							if (activeVariantBtn) {
								const variantIndex = Array.from(fieldset.querySelectorAll('.variant_btn')).indexOf(activeVariantBtn) + 1;
								stateParts.push(variantIndex);
							}
						});
					}

					let stepString = stateParts.join('-');

					// Capture custom text inputs or checkboxes
					const inputFields = activeLi.querySelectorAll(`
						:scope > .product_fields input:not(:disabled), 
						:scope > .product_fields textarea:not(:disabled), 
						:scope > .child_options .product_fields input:not(:disabled), 
						:scope > .child_options .product_fields textarea:not(:disabled)
					`);

					if (inputFields.length) {
						const values = Array.from(inputFields).map(field => 
							field.type === 'checkbox' ? (field.checked ? '1' : '0') : encodeURIComponent(field.value)
						);
						stepString += ':' + values.join(':');
					}

					branchPath.push(stepString);

					const nestedUl = activeLi.querySelector('ul');
					if (nestedUl) traverseDepth(nestedUl);
				};

				const startUl = rootListItem.querySelector(':scope > ul');
				if (startUl) traverseDepth(startUl);

				// Root-level fields (liIndex 0)
				const rootFields = rootListItem.querySelectorAll(':scope > .product_fields input:not(:disabled), :scope > .product_fields textarea:not(:disabled)');
				if (rootFields.length) {
					const rootVals = Array.from(rootFields).map(f => f.type === 'checkbox' ? (f.checked ? '1' : '0') : encodeURIComponent(f.value));
					branchPath.push('0:' + rootVals.join(':'));
				}

				builderSegments.push(branchPath.join('_'));
			});

			allBuilderStates.push(builderSegments.join('~'));
		});

		const finalBuildString = allBuilderStates.join('.');
		const currentUrl = new URL(window.location);

		if (finalBuildString && finalBuildString.replace(/[.~]/g, '').length > 0) {
			currentUrl.searchParams.set('build', finalBuildString);
		} else {
			currentUrl.searchParams.delete('build');
		}

		window.history.replaceState(null, '', currentUrl.pathname + currentUrl.search);
		return currentUrl.href;
	};

	/**
	 * Reads the build string and programmatically triggers clicks to restore UI state.
	 */
	const initializeFromURL = async (builder, builderIndex) => {
		if (!initialBuildData || builder.getAttribute('data-init-done') === 'true') return;

		builder.setAttribute('data-init-done', 'true');
		builder.setAttribute('data-rehydrating', 'true');

		const builderSegments = initialBuildData.split('.');
		const myData = builderSegments[builderIndex];

		if (!myData) {
			builder.removeAttribute('data-rehydrating');
			isInitializingState = false;
			return;
		}

		await new Promise(resolve => setTimeout(resolve, 50));

		const rootUl = builder.querySelector(':scope > ul');
		if (!rootUl) {
			builder.removeAttribute('data-rehydrating');
			isInitializingState = false;
			return;
		}

		const majorSegments = myData.split('~');
		for (let i = 0; i < majorSegments.length; i++) {
			const segment = majorSegments[i];
			if (!segment) continue;

			const rootLi = rootUl.querySelector(`:scope > li:nth-child(${i + 1})`);
			if (!rootLi) continue;

			const steps = segment.split('_');
			let currentScope = rootLi;

			for (const step of steps) {
				if (!step) continue;

				const [statePart, ...textParts] = step.split(':');
				const indices = statePart.split('-').map(n => parseInt(n, 10));
				const liIndex = indices[0];
				const variantIndices = indices.slice(1);

				// Handle field updates for root or child
				if (liIndex === 0) {
					const fields = rootLi.querySelectorAll(':scope > .product_fields input, :scope > .product_fields textarea');
					textParts.forEach((text, idx) => {
						if (fields[idx]) {
							if (fields[idx].type === 'checkbox') fields[idx].checked = text === '1';
							else fields[idx].value = decodeURIComponent(text);
						}
					});
					continue;
				}

				const targetUl = currentScope.querySelector('ul');
				if (!targetUl) break;

				const targetLi = targetUl.querySelector(`:scope > li:nth-child(${liIndex})`);
				if (!targetLi) break;

				const btn = targetLi.querySelector(':scope > .product_btn, :scope > .option_btn');
				if (btn) {
					btn.dispatchEvent(new CustomEvent('click', { bubbles: true, detail: { ignore_defaults: true } }));
					await new Promise(res => setTimeout(res, 30));
				}

				// Trigger variant clicks
				variantIndices.forEach((vIdx, fsIdx) => {
					const fieldset = targetLi.querySelectorAll(':scope > .child_options > fieldset')[fsIdx];
					if (fieldset) {
						const vBtns = fieldset.querySelectorAll('.variant_btn');
						if (vBtns[vIdx - 1]) vBtns[vIdx - 1].click();
					}
				});

				// Update text values
				const allFields = targetLi.querySelectorAll(`
					:scope > .product_fields input, 
					:scope > .product_fields textarea, 
					:scope > .child_options .product_fields input, 
					:scope > .child_options .product_fields textarea
				`);
				textParts.forEach((text, idx) => {
					if (allFields[idx]) {
						if (allFields[idx].type === 'checkbox') allFields[idx].checked = text === '1';
						else allFields[idx].value = decodeURIComponent(text);
					}
				});

				currentScope = targetLi;
			}
		}

		builder.removeAttribute('data-rehydrating');
		isInitializingState = false;
		refreshUI(builder);
	};

	/**
	 * Deactivates all selections in a list and disables nested inputs.
	 */
	const resetActiveSelections = (ul) => {
		if (!ul) return;
		ul.querySelectorAll('.active').forEach(el => {
			el.classList.remove('active');
			if (el.hasAttribute('aria-checked')) el.setAttribute('aria-checked', 'false');
		});
		ul.querySelectorAll('.build_option_inputs input, .build_option_inputs textarea, .build_addon_inputs input').forEach(input => {
			input.disabled = true;
			input.setAttribute('disabled', '');
		});
	};

	/**
	 * Parses the variant JSON stored in the HTML li elements.
	 */
	const getVariantsData = (li) => {
		try {
			const jsonScript = li.querySelector('.variants-json');
			return jsonScript ? JSON.parse(jsonScript.textContent || '[]') : [];
		} catch (e) {
			return [];
		}
	};

	const findDefaultOrAvailableVariant = (variants) => 
		variants.find(v => v.default === true) || 
		variants.find(v => v.available === true) || 
		variants[0] || null;

	/**
	 * Grays out variant buttons that are incompatible or out of stock based on other selections.
	 */
	const updateVariantAvailability = (parentLi, variants) => {
		parentLi.querySelectorAll('fieldset').forEach((fieldset, fsIndex) => {
			fieldset.querySelectorAll('.variant_btn').forEach(btn => {
				const val = btn.textContent.trim();
				const currentOptions = Array.from(parentLi.querySelectorAll('fieldset')).map((fs, idx) => 
					(fsIndex === idx ? val : fs.querySelector('.variant_btn.active')?.textContent.trim() || null)
				);

				const match = variants.find(v => v.options.every((opt, i) => !currentOptions[i] || opt === currentOptions[i]));
				btn.classList.toggle('oos', !match || !match.available);
			});
		});
	};

	/**
	 * Automatically selects default child products when a parent category is clicked.
	 */
	const triggerDefaultChildren = (parentLi, ignore) => {
		if (ignore || parentLi.closest(BUILDER_SELECTOR).hasAttribute('data-rehydrating')) return;

		const childUl = parentLi.querySelector(':scope > .child_options > ul');
		if (!childUl || childUl.querySelector('.active')) return;

		const nestedItems = childUl.querySelectorAll(':scope > li > ul > li');
		nestedItems.forEach(li => {
			if (getVariantsData(li).some(v => v.default)) {
				li.querySelector('.product_btn')?.dispatchEvent(new CustomEvent('click', { bubbles: true, detail: { ignore_defaults: true } }));
			}
		});
	};

	/**
	 * Formats currency based on the cart currency found during initialization.
	 */
	const formatCurrencyDisplay = (valueInCents, forcePlus = false) => {
		const formatted = (valueInCents / 100).toLocaleString('en-CA', {
			style: 'currency',
			currency: cartCurrency,
			currencyDisplay: 'narrowSymbol'
		});
		return (forcePlus && valueInCents > 0) ? `+${formatted}` : formatted;
	};

	/**
	 * Synchronizes the main quantity input with hidden bundle quantity inputs.
	 */
	const syncBundleQuantities = (builder) => {
		const form = builder.closest('form');
		if (!form) return;

		const mainQty = form.querySelector('.block_product_purchase_atc .qty_input_container input.qty_input');
		if (!mainQty) return;

		const update = () => {
			const val = mainQty.value;
			builder.querySelectorAll('input.bundle_qty').forEach(i => i.value = val);
		};

		mainQty.addEventListener('input', update);
		mainQty.addEventListener('change', update);

		if (mainQty.getAttribute('data-sync-init')) return update();
		mainQty.setAttribute('data-sync-init', 'true');

		// Monitor programmatic changes to main quantity
		const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
		Object.defineProperty(mainQty, 'value', {
			get: function() { return descriptor.get.call(this); },
			set: function(v) {
				descriptor.set.call(this, v);
				const f = this.closest('form');
				if (f) f.querySelectorAll('.block_product_purchase_builder input.bundle_qty').forEach(i => i.value = v);
			}
		});
		update();
	};

	/**
	 * Recalculates price, updates the tally display, and handles preview images.
	 */
	const refreshUI = (builder) => {
		setTimeout(() => {
			if (builder.hasAttribute('data-rehydrating')) return;
			const form = builder.closest('form') || document;
			const parentBlock = builder.closest('.block_product_purchase');
			let totalCustomCost = 0;
			let outOfStockList = [];
			let allComponentsAvailable = true;
			let activeImages = [];
			const basePriceEl = form.querySelector('.variant_price.active .price');
			let baseCents = basePriceEl ? parseFloat(basePriceEl.textContent.replace(/[^0-9.]/g, '')) * 100 : 0;
			const builderId = builder.querySelector(':scope > ul')?.getAttribute('data-id');
			form.querySelectorAll(BUILDER_SELECTOR).forEach(b => {
				b.querySelectorAll('input.bundle_variant:not(:disabled)').forEach(input => {
					totalCustomCost += Number(input.getAttribute('data-price') || 0);
					const li = input.closest('.build_option_inputs')?.closest('.child_options')?.closest('li') || input.closest('li');
					if (!li) return;
					const variants = getVariantsData(li);
					if (!variants || !variants.length) return;
					const currentV = variants.find(v => String(v.id) === String(input.value));
					if (currentV) {
						if (currentV.img) activeImages.push({ src: currentV.img, z: currentV['z-index'] || null });
						if (!currentV.available) {
							const btnLabel = li.querySelector(':scope > .product_btn, :scope > .option_btn');
							let labelText = 'Unknown';
							if (btnLabel) {
								const spanText = btnLabel.querySelector('span:not(.msg)');
								labelText = spanText ? spanText.textContent.trim() : btnLabel.textContent.replace(/\+\$[0-9.]+/g, '').trim();
							} else {
								const backupLabel = li.querySelector('.bundle_option_value') || li.parentElement.closest('li')?.querySelector('.bundle_option_value');
								if (backupLabel) labelText = backupLabel.value || backupLabel.textContent.trim();
							}
							outOfStockList.push(labelText);
							allComponentsAvailable = false;
						}
					}
				});
				b.querySelectorAll('input.addon_variant:not(:disabled)').forEach(input => {
					totalCustomCost += Number(input.getAttribute('data-price') || 0);
				});
				b.querySelectorAll('.option_btn.active').forEach(btn => {
					const diff = btn.querySelector('.price_diff');
					const val = diff ? diff.getAttribute('data-price') : btn.getAttribute('data-price');
					if (val) totalCustomCost += Number(val);
				});
			});
			if (builderId) {
				const preview = document.querySelector(`.builder_preview[data-id="${builderId}"]`);
				if (preview) {
					preview.querySelectorAll('img.active').forEach(i => i.remove());
					activeImages.forEach(obj => {
						const img = new Image();
						img.src = obj.src;
						img.className = 'active';
						if (obj.z !== null) img.style.zIndex = obj.z;
						preview.appendChild(img);
					});
				}
			}
			const atc = form.querySelector('.block_product_purchase_atc');
			if (atc) {
				atc.setAttribute('data-build-available', allComponentsAvailable);
				atc.dispatchEvent(new CustomEvent('bundleStatusUpdate', { bubbles: true, detail: { available: allComponentsAvailable } }));
			}
			form.querySelectorAll('.block_product_purchase_price .tally_container').forEach(display => {
				display.innerHTML = `
					<div class="tally_customizations"><b>Customizations:</b> ${formatCurrencyDisplay(totalCustomCost, true)}</div>
					${outOfStockList.length ? `<div class="builder_unavailalbe"><b>Unavailable:</b><ul>${outOfStockList.map(p => `<li>${p}</li>`).join('')}</ul></div>` : ''}
					<div class="tally_total"><b>Total:</b> ${formatCurrencyDisplay(baseCents + totalCustomCost)}</div>
				`;
			});

			const updatedUrl = updateURLState();

			if (parentBlock && parentBlock.getAttribute('data-is-pdp-product') === 'true') {
				const seoScript = document.querySelector('script[type="application/ld+json"]');
				if (seoScript) {
					try {
						let json = JSON.parse(seoScript.textContent);
						let minExt = 0, maxExt = 0;

						builder.querySelectorAll('ul[role="radiogroup"]').forEach(group => {
							let groupPrices = [];
							group.querySelectorAll(':scope > li').forEach(li => {
								const variants = getVariantsData(li);
								if (variants && variants.length) {
									const p = variants.map(x => x.price || 0);
									groupPrices.push(Math.min(...p), Math.max(...p));
								} else {
									const optionBtn = li.querySelector('.option_btn');
									if (optionBtn) groupPrices.push(Number(optionBtn.getAttribute('data-price') || 0));
								}
							});
							if (groupPrices.length) {
								minExt += Math.min(...groupPrices);
								maxExt += Math.max(...groupPrices);
							}
						});

						const finalPrice = (baseCents + totalCustomCost) / 100;
						json["@type"] = "ProductGroup";
						json.offers = {
							"@type": "AggregateOffer",
							"lowPrice": ((baseCents + minExt) / 100).toFixed(2),
							"highPrice": ((baseCents + maxExt) / 100).toFixed(2),
							"price": finalPrice.toFixed(2),
							"priceCurrency": cartCurrency,
							"offerCount": "1000",
							"url": updatedUrl
						};
						json.url = updatedUrl;
						seoScript.textContent = JSON.stringify(json);
					} catch (e) {}
				}
			}
		}, 10);
	};

	/**
	 * Handles all click events inside the builder using delegation.
	 */
	const handleBuilderClick = (e) => {
		const builder = e.target.closest(BUILDER_SELECTOR);
		if (!builder) return;
		const productBtn = e.target.closest('.product_btn');
		const optionBtn = e.target.closest('.option_btn');
		const titleBtn = e.target.closest('.option_title');
		const variantBtn = e.target.closest('.variant_btn');
		if (titleBtn) {
			const isExp = titleBtn.getAttribute('aria-expanded') === 'true';
			titleBtn.setAttribute('aria-expanded', !isExp);
			if (!isExp) { trackAnalyticsEvent('cue_builder_section_click', { section_name: titleBtn.textContent.trim() })}; 
			return titleBtn.classList.toggle('active');
		}
		if (productBtn || optionBtn || variantBtn) {
			const btn = productBtn || optionBtn || variantBtn;
			const li = btn.closest('li');
			const ul = btn.closest('ul');
			const ignoreDefaults = e.detail?.ignore_defaults || false;
			if (!variantBtn) resetActiveSelections(ul);
			if (optionBtn || productBtn) {
				btn.classList.add('active');
				if (btn.hasAttribute('aria-checked')) btn.setAttribute('aria-checked', 'true');
				if (!ignoreDefaults) {
					const sectionTitle = btn.closest('ul').closest('li')?.querySelector(':scope > .option_title');
					if (sectionTitle) {
						sectionTitle.classList.add('active');
						sectionTitle.setAttribute('aria-expanded', 'true');
					}
				}
				const displayVal = ul.closest('li')?.querySelector(':scope > .bundle_option_value');
				if (displayVal && optionBtn) {
					displayVal.value = optionBtn.textContent.split('$')[0].trim();
					trackAnalyticsEvent('cue_builder_option_click', { type: 'Builder Option', value: displayVal.value });
				}
			}
			if (variantBtn) {
				if (variantBtn.classList.contains('swatch')) {
					const legendSpan = variantBtn.closest('fieldset')?.querySelector('legend .swatch_value');
					if (legendSpan) {
						legendSpan.textContent = `: ${variantBtn.textContent.trim()}`;
					}
				}
			}
			if (ul && !variantBtn) {
				ul.querySelectorAll(':scope > li').forEach(item => {
					const best = findDefaultOrAvailableVariant(getVariantsData(item));
					const msg = item.querySelector('.product_btn .msg');
					if (msg && best) msg.textContent = best.default ? '(Included)' : formatCurrencyDisplay(best.price, true);
				});
			}
			if (productBtn || variantBtn) {
				const variants = getVariantsData(li);
				let activeV = null;
				if (variantBtn) {
					li.querySelector('.product_btn')?.classList.add('active');
					variantBtn.closest('fieldset').querySelectorAll('.variant_btn').forEach(b => {
						b.classList.remove('active');
						if (b.hasAttribute('aria-checked')) b.setAttribute('aria-checked', 'false');
					});
					variantBtn.classList.add('active');
					if (variantBtn.hasAttribute('aria-checked')) variantBtn.setAttribute('aria-checked', 'true');

					const selectedOpts = Array.from(li.querySelectorAll('fieldset')).map(f => f.querySelector('.variant_btn.active')?.textContent.trim() || null);
					activeV = variants.find(v => v.options.every((o, i) => !selectedOpts[i] || o === selectedOpts[i]));
				} else {
					activeV = findDefaultOrAvailableVariant(variants);
					if (activeV?.options) {
						li.querySelectorAll('fieldset').forEach((fs, i) => {
							fs.querySelectorAll('.variant_btn').forEach(vb => {
								const isMatch = vb.textContent.trim() === activeV.options[i];
								vb.classList.toggle('active', isMatch);
								if (vb.hasAttribute('aria-checked')) vb.setAttribute('aria-checked', isMatch);
								if (isMatch && vb.classList.contains('swatch')) {
									const legendSpan = fs.querySelector('legend .swatch_value');
									if (legendSpan) {
										legendSpan.textContent = `: ${vb.textContent.trim()}`;
									}
								}
							});
						});
					}
				}
				li.querySelectorAll(`
					:scope > .product_fields input, 
					:scope > .product_fields textarea, 
					:scope > .child_options > .build_option_inputs input, 
					:scope > .child_options > .build_option_inputs textarea,
					:scope > .child_options > .build_addon_inputs input,
					:scope > .child_options > ul > li > .build_option_inputs input,
					:scope > .child_options > ul > li > .build_option_inputs textarea,
					:scope > .child_options > ul > li > .build_addon_inputs input
				`).forEach(i => {
					i.disabled = false;
					i.removeAttribute('disabled');
				});
				updateVariantAvailability(li, variants);
				const varInput = li.querySelector('.bundle_variant');
				if (varInput && activeV) {
					varInput.value = String(activeV.id);
					varInput.setAttribute('data-price', activeV.price || 0);
					const rootLi = li.closest('.block_product_purchase_builder > ul > li');
					if (rootLi) {
						rootLi.querySelectorAll(':scope > .build_option_inputs input, :scope > .build_option_inputs textarea, :scope > .build_addon_inputs input').forEach(i => {
							if (activeV.excluded) {
								i.disabled = true;
								i.setAttribute('disabled', '');
							} else {
								i.disabled = false;
								i.removeAttribute('disabled');
							}
						});
					}
					const valInput = li.closest('ul')?.closest('li')?.querySelector(':scope > .bundle_option_value');
					if (valInput) valInput.value = activeV.title;
					
					trackAnalyticsEvent('cue_builder_option_click', { type: 'Builder Product', value: activeV.title, id: activeV.id, price: activeV.price / 100 });
					
					if (activeV.excluded) {
						li.querySelectorAll('.build_option_inputs input, .build_option_inputs textarea, .build_addon_inputs input').forEach(i => {
							i.disabled = true;
							i.setAttribute('disabled', '');
						});
					}
					const msg = li.querySelector('.product_btn .msg');
					if (msg) msg.textContent = activeV.default ? '(Included)' : formatCurrencyDisplay(activeV.price, true);
				}
				triggerDefaultChildren(li, ignoreDefaults);

				const contextRoot = li.closest('.block_product_purchase_builder > ul > li') || li;
				
				contextRoot.querySelectorAll('.child_options > ul[data-id]').forEach(childUl => {
					const parentStepLi = childUl.closest('.child_options')?.closest('li');
					if (parentStepLi && !parentStepLi.querySelector(':scope > .product_btn.active, :scope > .option_btn.active')) {
						return;
					}

					if (!childUl.querySelector(':scope > li .product_btn.active, :scope > li .option_btn.active')) {
						const firstBtn = childUl.querySelector(':scope > li .product_btn, :scope > li .option_btn');
						if (firstBtn) {
							firstBtn.classList.add('active');
							if (firstBtn.hasAttribute('aria-checked')) firstBtn.setAttribute('aria-checked', 'true');
							
							if (firstBtn.classList.contains('option_btn')) {
								const stepValInput = childUl.closest('li')?.querySelector(':scope > .bundle_option_value');
								if (stepValInput) {
									stepValInput.value = firstBtn.textContent.split('$')[0].trim();
								}
							} else {
								const firstLi = firstBtn.closest('li');
								const fallbackVariants = getVariantsData(firstLi);
								if (fallbackVariants && fallbackVariants.length) {
									const defaultOrFirstV = findDefaultOrAvailableVariant(fallbackVariants) || fallbackVariants[0];
									const fallbackVarInput = firstLi.querySelector('.bundle_variant');
									if (fallbackVarInput && defaultOrFirstV) {
										fallbackVarInput.value = String(defaultOrFirstV.id);
										fallbackVarInput.setAttribute('data-price', defaultOrFirstV.price || 0);
									}
									const firstStepValInput = childUl.closest('li')?.querySelector(':scope > .bundle_option_value');
									if (firstStepValInput && defaultOrFirstV) {
										firstStepValInput.value = defaultOrFirstV.title;
									}
								}
							}
						}
					}
				});

				const applyDeepExclusions = (scopeLi) => {
					scopeLi.querySelectorAll('.child_options > ul[data-id] > li').forEach(stepLi => {
						const stepValInput = stepLi.querySelector(':scope > .bundle_option_value');
						const addonContainers = stepLi.querySelectorAll(':scope > .build_option_inputs, :scope > .build_addon_inputs');
						stepLi.querySelectorAll('.options > li').forEach(subLi => {
							const subVariants = getVariantsData(subLi);
							if (!subVariants || !subVariants.length) return;
							let subActiveV = null;
							const activeBtn = subLi.querySelector('.product_btn.active');
							if (activeBtn) {
								if (subLi.querySelector('.variant_btn')) {
									const subOpts = Array.from(subLi.querySelectorAll('fieldset')).map(f => f.querySelector('.variant_btn.active')?.textContent.trim() || null);
									subActiveV = subVariants.find(v => v.options.every((o, i) => !subOpts[i] || o === subOpts[i])) || subVariants.find(v => v.default) || subVariants[0];
								} else {
									subActiveV = subVariants.find(v => v.default || v.id === parseInt(subLi.querySelector('.bundle_variant')?.value)) || subVariants[0];
								}
								
								if (subActiveV && subActiveV.excluded) {
									subLi.querySelectorAll('.build_option_inputs input, .build_option_inputs textarea, .build_addon_inputs input').forEach(i => {
										i.disabled = true;
										i.setAttribute('disabled', '');
									});
									if (stepValInput) {
										stepValInput.disabled = false;
										stepValInput.removeAttribute('disabled');
									}
									addonContainers.forEach(container => {
										container.querySelectorAll('input, textarea').forEach(addonInput => {
											addonInput.disabled = true;
											addonInput.setAttribute('disabled', '');
										});
									});
								} else if (subActiveV) {
									addonContainers.forEach(container => {
										container.querySelectorAll('input, textarea').forEach(addonInput => {
											addonInput.disabled = false;
											addonInput.removeAttribute('disabled');
										});
									});
								}
							}
							if (subLi.querySelector('.child_options')) {
								applyDeepExclusions(subLi);
							}
						});
					});
				};
				applyDeepExclusions(contextRoot);
			}
			refreshUI(builder);
		}
	};
	 
	 

	// --- Lifecycle Logic ---
	getCurrencyCode().then(() => {
		const builders = document.querySelectorAll(BUILDER_SELECTOR);
		updateBundleGroupIDs();
		builders.forEach((b, idx) => {
			syncBundleQuantities(b);
			const start = () => initializeFromURL(b, idx);
			if (document.readyState === 'complete') start();
			else window.addEventListener('load', start);
			refreshUI(b);
			// Track every section header that the user sees on load
			b.querySelectorAll('.option_title').forEach(titleBtn => {
				trackAnalyticsEvent('cue_builder_section_impression', { section_name: titleBtn.textContent.trim() });
			});
		});
		document.addEventListener('click', handleBuilderClick);
		document.addEventListener('change', e => {
			if (e.target.closest('.product_fields')) updateURLState();
		});
		document.addEventListener('input', e => {
			if (e.target.closest('.product_fields') && e.target.type !== 'checkbox') updateURLState();
		});

		// Validation before adding to cart
		document.addEventListener('submit', e => {
			const b = e.target.querySelector(BUILDER_SELECTOR);
			if (!b) return;
			const requiredFields = Array.from(b.querySelectorAll('.product_fields input[required]:not(:disabled), .product_fields textarea[required]:not(:disabled)'))
				.filter(f => !f.value.trim());

			if (requiredFields.length) {
				e.preventDefault();
				e.stopPropagation();
				requiredFields[0].focus();
				requiredFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
				requiredFields[0].classList.add('error');
				setTimeout(() => requiredFields[0].classList.remove('error'), 3000);
				alert('Please fill out the required customization fields before adding to cart.');
			} else {
				// Dynamically map all active values chosen by the user into a quick string array
				const chosenOptions = Array.from(b.querySelectorAll('.bundle_option_value')).map(input => input.value.trim()).filter(Boolean);
				trackAnalyticsEvent('cue_builder_add_to_cart', { final_configuration: chosenOptions.join(', ') });
			}
		}, true);
		document.addEventListener('variantSelected', () => builders.forEach(b => refreshUI(b)));
		document.addEventListener('cartUpdate', updateBundleGroupIDs);
	});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-purchase-price"] && !Shopify.designMode) return;
  try {
    // blocks/product-purchase-price.liquid
	// document.addEventListener("variantSelected",((t)=>{const{variantId:e,productId:n}=t.detail,r=document.querySelector(`.variant_prices[data-product-id="${n}"]`);if(!r)return;const a=r.querySelectorAll(".variant_price");a.forEach((t=>t.classList.remove("active")));const i=r.querySelector(`.variant_price[data-id="${e}"]`);i?i.classList.add("active"):a.length>0&&a[0].classList.add("active")}));


document.addEventListener("variantSelected",(t=>{const{variantId:e,productId:n}=t.detail;document.querySelectorAll(`.variant_prices[data-product-id="${n}"]`).forEach((r=>{const a=r.querySelectorAll(".variant_price");a.forEach((t=>t.classList.remove("active")));const i=r.querySelector(`.variant_price[data-id="${e}"]`);i?i.classList.add("active"):a.length>0&&a[0].classList.add("active")}))}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-purchase-variant-detail"] && !Shopify.designMode) return;
  try {
    // blocks/product-purchase-variant-details.liquid
document.addEventListener("variantSelected",e=>{const{productId:t,variantId:a}=e.detail||{};document.querySelectorAll(`.variant_details_conatiner[data-product-id="${t}"]`).forEach(t=>{t.querySelectorAll(".variant_details").forEach(t=>{t.classList.remove("active")});const r=t.querySelector(`.variant_details[data-id="${a}"]`);r&&r.classList.add("active")})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-purchase-variant"] && !Shopify.designMode) return;
  try {
    // blocks/product-purchase-variant.liquid
document.addEventListener('DOMContentLoaded', () => {

	function updateVariantUrlParam(variantId) {
		const url = new URL(window.location);
		url.searchParams.set('variant', variantId);
		window.history.replaceState({}, '', url);
	}

	const optionsSelector = document.querySelector('.product_options_selector');

	if (optionsSelector) {
		const hiddenInput = optionsSelector.querySelector('input[type="hidden"]');

		if (!hiddenInput) {
			return;
		}

		const variantsJson = optionsSelector.getAttribute('data-product-variants');
		const productId = Number(optionsSelector.getAttribute('data-product'));
		const variants = JSON.parse(variantsJson);

		if (!variants || variants.length === 0) {
			return;
		}

		const optionButtons = optionsSelector.querySelectorAll('.option_button');
		const optionGroups = optionsSelector.querySelectorAll('.option_group');

		function dispatchVariantSelected(el, variantId, productId, quantity) {
			const detail = { variantId: Number(variantId), productId: Number(productId) };

			if (quantity !== null && quantity !== undefined) {
				detail.quantity = Number(quantity);
			}

			el.dispatchEvent(new CustomEvent('variantSelected', { bubbles: true, detail }));

			if (typeof gtag === 'function') {
				gtag('event', 'select_variant', { variant_id: Number(variantId), product_id: Number(productId), inventory_quantity: quantity !== null && quantity !== undefined ? Number(quantity) : null });
			}
		}

		function dispatchMediaSelected(el, mediaId, productId) {
			el.dispatchEvent(new CustomEvent('mediaSelected', { bubbles: true, detail: { mediaId: Number(mediaId), productId: Number(productId) } }));
		}

		function getSelectedOptionValues() {
			const values = [];

			optionGroups.forEach(group => {
				const activeButton = group.querySelector('.option_button.active');

				if (activeButton) {
					values.push(activeButton.getAttribute('data-option-value').toLowerCase().trim());
				}
			});

			return values.filter(value => value !== null);
		}

		function findVariantByOptions(optionValues) {
			return variants.find(variant => {
				const variantOptions = variant.options.map(o => o.toLowerCase().trim()).filter(Boolean);
				return variantOptions.length === optionValues.length && optionValues.every((value, i) => value === variantOptions[i]);
			});
		}

		function updateSwatchLabels() {
			optionGroups.forEach(group => {
				if (!group.querySelector('.swatch')) {
					return;
				}

				const label = group.previousElementSibling;
				const activeButton = group.querySelector('.option_button.active');

				if (label && activeButton) {
					const labelPrefix = label.innerText.split(':')[0];
					label.innerText = labelPrefix + ': ' + activeButton.getAttribute('data-option-value');
				}
			});
		}

		function updateOptionAvailability() {
			const variantsList = Array.isArray(variants) ? variants : [];

			optionButtons.forEach(button => {
				const group = button.closest('.option_group');
				const buttonValue = button.getAttribute('data-option-value').toLowerCase().trim();
				const groupIndex = Array.from(optionGroups).indexOf(group);
				const groupCount = optionGroups.length;

				const hypotheticalSelection = new Array(groupCount).fill(null).map((_, groupIdx) => {
					if (groupIdx === groupIndex) {
						return buttonValue;
					}

					const activeInGroup = optionGroups[groupIdx].querySelector('.option_button.active');
					return activeInGroup ? activeInGroup.getAttribute('data-option-value').toLowerCase().trim() : null;
				}).filter(Boolean);

				const matchingVariant = variantsList.find(variant => {
					const variantOptions = variant.options.map(o => o.toLowerCase().trim()).filter(Boolean);
					return variantOptions.length === hypotheticalSelection.length && hypotheticalSelection.every((value, i) => value === variantOptions[i]);
				});

				if (matchingVariant) {
					if (matchingVariant.available) {
						button.classList.remove('disabled');
						button.classList.remove('unavailable');
						button.setAttribute('title', button.getAttribute('data-option-value'));
					} else {
						button.classList.add('disabled');
						button.classList.remove('unavailable');
						button.setAttribute('title', 'Sold Out');
					}
				} else {
					button.classList.add('disabled');
					button.classList.add('unavailable');
					button.setAttribute('title', 'Not Available');
				}

				if (button.classList.contains('unavailable')) {
					button.setAttribute('disabled', 'disabled');
				} else {
					button.removeAttribute('disabled');
				}
			});
		}

		optionButtons.forEach(button => {
			button.addEventListener('click', () => {
				const group = button.closest('.option_group');
				group.querySelectorAll('.option_button').forEach(b => b.classList.remove('active'));
				button.classList.add('active');

				const selectedValues = getSelectedOptionValues();
				const matchedVariant = findVariantByOptions(selectedValues);

				updateSwatchLabels();

				if (matchedVariant) {
					hiddenInput.value = matchedVariant.id;
					updateVariantUrlParam(matchedVariant.id);
					dispatchVariantSelected(optionsSelector, matchedVariant.id, productId, matchedVariant.inventory_quantity);

					if (matchedVariant.featured_media && Number(matchedVariant.featured_media) !== 0) {
						dispatchMediaSelected(optionsSelector, matchedVariant.featured_media, productId);
					}
				} else {
					hiddenInput.value = '';
				}

				updateOptionAvailability();
			});
		});

		updateSwatchLabels();
		updateOptionAvailability();
	}

	const variantSelect = document.querySelector('.variant_select');

	if (variantSelect) {
		const productId = Number(variantSelect.getAttribute('data-product'));

		function dispatchVariantSelected(el, variantId, productId, quantity) {
			const detail = { variantId: Number(variantId), productId: Number(productId) };

			if (quantity !== null && quantity !== undefined) {
				detail.quantity = Number(quantity);
			}

			el.dispatchEvent(new CustomEvent('variantSelected', { bubbles: true, detail }));

			if (typeof gtag === 'function') {
				gtag('event', 'select_variant', { variant_id: Number(variantId), product_id: Number(productId), inventory_quantity: quantity !== null && quantity !== undefined ? Number(quantity) : null });
			}
		}

		function dispatchMediaSelected(el, mediaId, productId) {
			el.dispatchEvent(new CustomEvent('mediaSelected', { bubbles: true, detail: { mediaId: Number(mediaId), productId: Number(productId) } }));
		}

		variantSelect.addEventListener('change', event => {
			const selectedVariantId = event.target.value;
			const selectedOption = event.target.options[event.target.selectedIndex];
			const featuredMedia = selectedOption.getAttribute('data-featured-media');
			const inventoryQuantity = selectedOption.getAttribute('data-inventory-quantity');

			updateVariantUrlParam(selectedVariantId);
			dispatchVariantSelected(variantSelect, selectedVariantId, productId, inventoryQuantity);

			if (featuredMedia && Number(featuredMedia) !== 0) {
				dispatchMediaSelected(variantSelect, featuredMedia, productId);
			}
		});
	}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // blocks/accordion.liquid
	document.addEventListener('DOMContentLoaded', () => {

		function toggleContentFocus(contentWrapper, disable) {
			const focusableElements = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

			contentWrapper.querySelectorAll(focusableElements).forEach(el => {
				if (disable) {
					el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') || '0');
					el.setAttribute('tabindex', '-1');
				} else {
					const originalTabindex = el.getAttribute('data-original-tabindex');

					if (originalTabindex) {
						el.setAttribute('tabindex', originalTabindex);
					} else {
						el.removeAttribute('tabindex');
					}

					el.removeAttribute('data-original-tabindex');
				}
			});
		}

		function pauseVideos(contentWrapper) {
			contentWrapper.querySelectorAll('video').forEach(video => {
				video.pause();
			});
		}

		function openAccordionInEditor(blockElement) {
			const contentWrapper = blockElement.querySelector('.accordion_content');
			blockElement.classList.add('active');
			blockElement.classList.remove('prevent_animate');

			if (contentWrapper) {
				contentWrapper.style.maxHeight = 'none';
				contentWrapper.removeAttribute('aria-hidden');
				toggleContentFocus(contentWrapper, false);
			}

			window.dispatchEvent(new Event('active_animate'));
		}

		function closeAccordionInEditor(blockElement) {
			const contentWrapper = blockElement.querySelector('.accordion_content');
			blockElement.classList.remove('active');
			blockElement.classList.add('prevent_animate');

			if (contentWrapper) {
				contentWrapper.style.maxHeight = '0';
				contentWrapper.setAttribute('aria-hidden', 'true');
				toggleContentFocus(contentWrapper, true);
				pauseVideos(contentWrapper);
			}

			window.dispatchEvent(new Event('active_animate'));
		}

		function closeNonDefaultAccordions() {
			document.querySelectorAll('.block_accordion').forEach(a => {
				const isSelected = a.hasAttribute('data-shopify-editor-block-selected') || a.querySelector('[data-shopify-editor-block-selected]');

				if (!isSelected && !a.classList.contains('default_open') && a.classList.contains('active')) {
					closeAccordionInEditor(a);
				}
			});
		}

		const inDesignMode = window.Shopify && window.Shopify.designMode;

		if (inDesignMode) {
			window.addEventListener('load', () => {
				const editorCheckAndAttachListeners = (container = document) => {
					if (!container || !container.querySelectorAll) {
						return;
					}

					const accordionBlocks = container.querySelectorAll('.block_accordion');

					accordionBlocks.forEach(blockAccordion => {
						const isCurrentlySelected = blockAccordion.hasAttribute('data-shopify-editor-block-selected');
						const isDescendantSelected = blockAccordion.querySelector('[data-shopify-editor-block-selected]');

						if (isCurrentlySelected || isDescendantSelected) {
							openAccordionInEditor(blockAccordion);
						}

						blockAccordion.addEventListener('shopify:block:select', () => {
							openAccordionInEditor(blockAccordion);
						});
					});
				};

				setTimeout(() => {
					editorCheckAndAttachListeners(document);
				}, 50);

				document.addEventListener('shopify:section:load', event => {
					editorCheckAndAttachListeners(event.target);
				});

				document.addEventListener('shopify:section:select', () => {
					closeNonDefaultAccordions();
				});
			});
		}

		const allAccordions = document.querySelectorAll('.block_accordion');

		allAccordions.forEach(blockAccordion => {
			const contentWrapper = blockAccordion.querySelector('.accordion_content');

			if (blockAccordion.classList.contains('active')) {
				if (contentWrapper) {
					contentWrapper.style.maxHeight = 'none';
					contentWrapper.removeAttribute('aria-hidden');
					toggleContentFocus(contentWrapper, false);
				}
			} else {
				closeAccordionInEditor(blockAccordion);
			}

			if (!inDesignMode) {
				blockAccordion.classList.add('prevent_animate');
			}
		});

		if (typeof toggleVisibilityOnScroll === 'function') {
			toggleVisibilityOnScroll();
		}

		if (typeof updateAnimationClasses === 'function') {
			updateAnimationClasses();
		}

		document.addEventListener('transitionend', e => {
			if (e.propertyName !== 'max-height' || !e.target.classList.contains('accordion_content')) {
				return;
			}

			const blockAccordion = e.target.closest('.block_accordion');

			if (blockAccordion && blockAccordion.classList.contains('active')) {
				e.target.style.maxHeight = 'none';
				window.dispatchEvent(new Event('active_animate'));
			}
		});

		document.addEventListener('click', e => {
			const heading = e.target.closest('.accordion_heading');

			if (!heading) {
				return;
			}

			const blockAccordion = heading.closest('.block_accordion');

			if (!blockAccordion) {
				return;
			}

			const contentWrapper = blockAccordion.querySelector('.accordion_content');

			if (!contentWrapper) {
				return;
			}

			const groupName = blockAccordion.getAttribute('data-accordion-group');
			const isActive = blockAccordion.classList.contains('active');

			if (!isActive) {
				document.querySelectorAll('.block_accordion.active[data-accordion-group="' + groupName + '"]').forEach(openAccordion => {
					if (openAccordion !== blockAccordion && !inDesignMode) {
						openAccordion.classList.remove('active');
						openAccordion.classList.add('prevent_animate');

						const openContent = openAccordion.querySelector('.accordion_content');
						const openHeading = openAccordion.querySelector('.accordion_heading');

						if (openContent.style.maxHeight === 'none') {
							openContent.style.maxHeight = openContent.scrollHeight + 'px';
						}

						setTimeout(() => {
							openContent.style.maxHeight = '0';
							openContent.setAttribute('aria-hidden', 'true');
							toggleContentFocus(openContent, true);
							pauseVideos(openContent);
						}, 1);

						if (openHeading) {
							openHeading.setAttribute('aria-expanded', 'false');
						}
					}
				});
			}

			if (isActive && inDesignMode) {
				return;
			}

			blockAccordion.classList.toggle('active');

			const newIsActive = blockAccordion.classList.contains('active');

			if (newIsActive) {
				blockAccordion.classList.remove('prevent_animate');
				contentWrapper.style.maxHeight = '0';
				contentWrapper.removeAttribute('aria-hidden');
				toggleContentFocus(contentWrapper, false);

				const innerContent = contentWrapper.firstElementChild;

				if (innerContent) {
					contentWrapper.style.maxHeight = innerContent.scrollHeight + 'px';
				}
			} else {
				blockAccordion.classList.add('prevent_animate');
				contentWrapper.style.maxHeight = contentWrapper.scrollHeight + 'px';

				setTimeout(() => {
					contentWrapper.style.maxHeight = '0';
					contentWrapper.setAttribute('aria-hidden', 'true');
					toggleContentFocus(contentWrapper, true);
					pauseVideos(contentWrapper);
				}, 1);
			}

			heading.setAttribute('aria-expanded', newIsActive);
			window.dispatchEvent(new Event('active_animate'));
		});
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai-chat"] && !Shopify.designMode) return;
  try {
    (function () {
	if (window.__aiChatBooted) return;
	window.__aiChatBooted = true;

	// Coupled to shopify.app.toml's [app_proxy] prefix/subpath in the
	// rack-grp-app repo — App Proxy paths are never locale-prefixed (unlike
	// /cart/add.js below), so these are plain literals, not routes.root_url
	// based. If that subpath is ever renamed again, these five need to move
	// with it.
	var STATUS_URL = '/apps/storefront/ai-agent/status';
	var MESSAGE_URL = '/apps/storefront/ai-agent/message';
	var POLL_URL = '/apps/storefront/ai-agent/poll';
	var CONVERSATIONS_URL = '/apps/storefront/ai-agent/conversations';
	var HISTORY_URL = '/apps/storefront/ai-agent/history';

	var STORAGE_PREFIX = 'ai_chat_';
	var POLL_INTERVAL_MS = 5000;
	var PER_CONVERSATION_HISTORY_LIMIT = 200;
	var MAX_LOCAL_CONVERSATIONS = 50;
	var LABEL_MAX_LENGTH = 60;

	function storageGet(key) {
		try {
			return window.localStorage.getItem(STORAGE_PREFIX + key);
		} catch (e) {
			return null;
		}
	}
	function storageSet(key, value) {
		try {
			window.localStorage.setItem(STORAGE_PREFIX + key, value);
		} catch (e) {
			/* localStorage unavailable (private browsing, etc.) — chat still works, just without cross-page memory */
		}
	}

	function getAnonymousId() {
		var id = storageGet('anonymous_id');
		if (!id) {
			id =
				window.crypto && window.crypto.randomUUID
					? window.crypto.randomUUID()
					: 'anon_' + Date.now() + '_' + Math.random().toString(36).slice(2);
			storageSet('anonymous_id', id);
		}
		return id;
	}

	function makeLocalId() {
		return window.crypto && window.crypto.randomUUID
			? window.crypto.randomUUID()
			: 'local_' + Date.now() + '_' + Math.random().toString(36).slice(2);
	}

	function getAiName() {
		return storageGet('ai_name') || 'the assistant';
	}
	function setAiName(name) {
		if (name) storageSet('ai_name', name);
	}

	// Every conversation this device knows about, newest-first isn't
	// enforced here — callers sort as needed. Each record: {localId,
	// conversationId (null until the first message creates one server-side),
	// label (null until there's a first user message to derive one from),
	// history: [{role, text, staffName}], lastMessageId, updatedAt}.
	// localId is this device's own stable handle, independent of whether a
	// server conversationId exists yet — needed so a freshly-started, never-
	// sent conversation can still be "the active one."
	function loadConversations() {
		try {
			return JSON.parse(storageGet('conversations') || '[]');
		} catch (e) {
			return [];
		}
	}
	function saveConversations(list) {
		if (list.length > MAX_LOCAL_CONVERSATIONS) {
			list = list.slice().sort(function (a, b) {
				return b.updatedAt - a.updatedAt;
			});
			list = list.slice(0, MAX_LOCAL_CONVERSATIONS);
		}
		storageSet('conversations', JSON.stringify(list));
	}
	function getActiveLocalId() {
		return storageGet('active_local_id');
	}
	function setActiveLocalId(localId) {
		storageSet('active_local_id', localId);
	}

	// Conversations a signed-in customer chose to remove from THIS device's
	// list — see the block's own doc comment in ai-shopping-assistant.md for
	// why this can't be a real server-side delete without a much bigger
	// (and separately declined) change: it's a per-device hide, not a
	// cross-device one. Keyed by server conversationId only — a local-only
	// conversation that was never sent has nothing server-side to hide, so
	// it's just spliced out of the conversations list directly instead.
	function getHiddenConversationIds() {
		try {
			return JSON.parse(storageGet('hidden_conversation_ids') || '[]');
		} catch (e) {
			return [];
		}
	}
	function hideConversationId(conversationId) {
		var hidden = getHiddenConversationIds();
		if (hidden.indexOf(conversationId) === -1) {
			hidden.push(conversationId);
			storageSet('hidden_conversation_ids', JSON.stringify(hidden));
		}
	}

	function createConversationRecord() {
		return { localId: makeLocalId(), conversationId: null, label: null, history: [], lastMessageId: 0, updatedAt: Date.now() };
	}

	function truncateLabel(text) {
		if (!text) return null;
		var oneLine = text.replace(/\s+/g, ' ').trim();
		return oneLine.length > LABEL_MAX_LENGTH ? oneLine.slice(0, LABEL_MAX_LENGTH - 1) + '…' : oneLine;
	}

	function appendToConversationHistory(record, entry) {
		record.history.push(entry);
		if (record.history.length > PER_CONVERSATION_HISTORY_LIMIT) {
			record.history = record.history.slice(-PER_CONVERSATION_HISTORY_LIMIT);
		}
	}

	// Reads, mutates via `mutator`, and persists one conversation record by
	// localId in a single pass — every write to a conversation's own state
	// (append a message, learn its server id, bump lastMessageId) goes
	// through this so the list in storage and the in-memory record a caller
	// is holding never drift apart.
	function updateConversation(localId, mutator) {
		var list = loadConversations();
		var idx = -1;
		for (var i = 0; i < list.length; i++) {
			if (list[i].localId === localId) {
				idx = i;
				break;
			}
		}
		if (idx === -1) return null;
		mutator(list[idx]);
		list[idx].updatedAt = Date.now();
		saveConversations(list);
		return list[idx];
	}

	function escapeHtml(str) {
		return String(str).replace(/[&<>"']/g, function (c) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
		});
	}

	// A minimal, safe Markdown renderer — not a general parser. Escapes
	// everything first (product/FAQ content is prompt-injectable, same XSS
	// concern the admin's react-markdown rendering guards against), then only
	// re-introduces the shapes GUARDRAILS actually produces: bold, links, and
	// bullet/numbered lists. No react-markdown equivalent exists client-side
	// in this theme.
	function renderMarkdown(text) {
		var escaped = escapeHtml(text);
		escaped = escaped.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g, function (m, label, url) {
			return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + '</a>';
		});
		escaped = escaped.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

		var lines = escaped.split('\n');
		var html = '';
		var listType = null;
		for (var i = 0; i < lines.length; i++) {
			var line = lines[i];
			var bulletMatch = line.match(/^[-*]\s+(.*)/);
			var numberedMatch = line.match(/^\d+\.\s+(.*)/);
			if (bulletMatch || numberedMatch) {
				var thisType = bulletMatch ? 'ul' : 'ol';
				if (listType !== thisType) {
					if (listType) html += '</' + listType + '>';
					html += '<' + thisType + '>';
					listType = thisType;
				}
				html += '<li>' + (bulletMatch ? bulletMatch[1] : numberedMatch[1]) + '</li>';
			} else {
				if (listType) {
					html += '</' + listType + '>';
					listType = null;
				}
				if (line.trim()) html += '<p>' + line + '</p>';
			}
		}
		if (listType) html += '</' + listType + '>';
		return html;
	}

	function parseSseFrames(buffer) {
		var frames = [];
		var parts = buffer.split('\n\n');
		var remainder = parts.pop();
		for (var i = 0; i < parts.length; i++) {
			var lines = parts[i].split('\n');
			var eventLine, dataLine;
			for (var j = 0; j < lines.length; j++) {
				if (lines[j].indexOf('event:') === 0) eventLine = lines[j];
				if (lines[j].indexOf('data:') === 0) dataLine = lines[j];
			}
			if (!eventLine || !dataLine) continue;
			try {
				frames.push({ event: eventLine.slice(6).trim(), data: JSON.parse(dataLine.slice(5).trim()) });
			} catch (e) {
				/* malformed frame — skip, the stream itself keeps going */
			}
		}
		return { frames: frames, remainder: remainder };
	}

	function initAiChat(root) {
		if (root.__aiChatBound) return;
		root.__aiChatBound = true;

		var messagesEl = root.querySelector('.ai_chat_messages');
		var unavailableEl = root.querySelector('.ai_chat_unavailable');
		var formEl = root.querySelector('.ai_chat_form');
		var inputEl = root.querySelector('.ai_chat_input');
		var sendBtn = root.querySelector('.ai_chat_send');
		var historyToggleBtn = root.querySelector('.ai_chat_history_toggle');
		var newConversationBtn = root.querySelector('.ai_chat_new_btn');
		var historyPanelEl = root.querySelector('.ai_chat_history_panel');
		var historyCancelBtn = root.querySelector('.ai_chat_history_cancel');
		var historyAddBtn = root.querySelector('.ai_chat_history_add');
		var historyListEl = root.querySelector('.ai_chat_history_list');
		var historyEmptyEl = root.querySelector('.ai_chat_history_empty');
		var introText = root.getAttribute('data-intro-text') || 'Ask a question to get started.';
		var iconStyle = root.getAttribute('data-icon-style') || 'regular';
		var currentProductId = root.getAttribute('data-current-product-id') || null;

		var anonymousId = getAnonymousId();
		var pollTimer = null;
		var sending = false;
		// Fetched lazily on first History-panel open, not on every page load —
		// most visits never open the switcher, so there's no reason to spend a
		// request on it up front. null until fetched; [] once fetched for a
		// guest or a customer with no other conversations.
		var remoteConversations = null;

		function findLocalConversation(localId) {
			var list = loadConversations();
			for (var i = 0; i < list.length; i++) {
				if (list[i].localId === localId) return list[i];
			}
			return null;
		}

		function resolveInitialActiveConversation() {
			var activeId = getActiveLocalId();
			var record = activeId ? findLocalConversation(activeId) : null;
			if (record) return record;

			var list = loadConversations();
			if (list.length) {
				record = list.slice().sort(function (a, b) {
					return b.updatedAt - a.updatedAt;
				})[0];
				setActiveLocalId(record.localId);
				return record;
			}

			record = createConversationRecord();
			list.push(record);
			saveConversations(list);
			setActiveLocalId(record.localId);
			return record;
		}

		var active = resolveInitialActiveConversation();

		function scrollToBottom(instant) {
			window.setTimeout(function () {
				messagesEl.scrollTo({ top: messagesEl.scrollHeight, behavior: instant ? 'auto' : 'smooth' });
			}, 0);
		}

		function addBubble(role, staffName) {
			var bubble = document.createElement('div');
			bubble.className = 'ai_chat_message ai_chat_message--' + role;
			var label = document.createElement('span');
			label.className = 'ai_chat_message_label';
			label.textContent = role === 'user' ? 'You' : role === 'staff' ? staffName || 'Staff' : getAiName();
			var content = document.createElement('div');
			content.className = 'ai_chat_message_content';
			bubble.appendChild(label);
			bubble.appendChild(content);
			messagesEl.appendChild(bubble);
			return content;
		}

		function renderActiveConversation() {
			// Cleared unconditionally first, not just when empty — some
			// placements (e.g. this block cloned by a Popup's own
			// cloneNode(true) after the hidden original already rendered its
			// own copy of this same history) can hand this element to
			// initAiChat with history already baked into its markup. The
			// active record's own history array is the single source of
			// truth; whatever's already sitting in the DOM here is never
			// trusted, only replaced.
			messagesEl.innerHTML = '';
			if (!active.history.length) {
				var intro = document.createElement('p');
				intro.className = 'ai_chat_empty';
				intro.textContent = introText;
				messagesEl.appendChild(intro);
				return;
			}
			active.history.forEach(function (entry) {
				var content = addBubble(entry.role, entry.staffName);
				content.innerHTML = entry.role === 'user' ? escapeHtml(entry.text) : renderMarkdown(entry.text);
			});
			scrollToBottom(true);
		}

		function setUnavailable() {
			if (unavailableEl) unavailableEl.hidden = false;
			inputEl.disabled = true;
			sendBtn.disabled = true;
		}

		function setAvailable(aiName) {
			setAiName(aiName);
			inputEl.disabled = false;
			sendBtn.disabled = !inputEl.value.trim();
			inputEl.placeholder = 'Ask ' + (aiName || 'us') + '...';
		}

		function stopPolling() {
			if (pollTimer) {
				window.clearInterval(pollTimer);
				pollTimer = null;
			}
		}

		function pollForUpdates() {
			// A placement whose DOM gets torn down and rebuilt elsewhere
			// (e.g. a Popup clearing/replacing its cloned content on close)
			// never tells this instance to stop — without this check, every
			// open+close cycle leaks another setInterval polling forever
			// against an element no page can see anymore.
			if (!document.contains(root)) {
				stopPolling();
				return;
			}
			if (!active.conversationId) return;
			var url =
				POLL_URL +
				'?conversationId=' +
				encodeURIComponent(active.conversationId) +
				'&afterMessageId=' +
				active.lastMessageId +
				'&anonymousId=' +
				encodeURIComponent(anonymousId);
			fetch(url)
				.then(function (res) {
					return res.ok ? res.json() : null;
				})
				.then(function (data) {
					if (!data || !data.messages || !data.messages.length) return;
					data.messages.forEach(function (m) {
						var content = addBubble(m.role, m.staffName);
						content.innerHTML = renderMarkdown(m.content);
					});
					scrollToBottom(false);
					var localId = active.localId;
					active =
						updateConversation(localId, function (record) {
							data.messages.forEach(function (m) {
								appendToConversationHistory(record, { role: m.role, text: m.content, staffName: m.staffName });
								if (m.id > record.lastMessageId) record.lastMessageId = m.id;
							});
						}) || active;
				})
				.catch(function () {
					/* best-effort — retried next interval */
				});
		}

		function startPolling() {
			stopPolling();
			if (!active.conversationId) return;
			pollTimer = window.setInterval(pollForUpdates, POLL_INTERVAL_MS);
		}

		// Firing one fetch('/cart/add.js') per cart_add event, as soon as each
		// one arrived, sent them concurrently whenever a turn added more than
		// one product — confirmed live (2026-08-10, a bar + 4 stools in one
		// turn) as a real bug, not a hypothetical: only the first request's
		// item actually landed in the cart. Shopify's /cart/add.js accepts a
		// multi-item `items` array in one request specifically for this case;
		// batching every item from a single turn into ONE request, sent only
		// once the turn is fully done, sidesteps the race entirely instead of
		// serializing N separate round trips.
		function flushCartAdds(items) {
			if (!items.length) return;
			var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
			fetch(cartRoot + 'cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ items: items }),
			})
				.then(function () {
					document.dispatchEvent(new CustomEvent('cartUpdate'));
				})
				.catch(function () {
					/* the AI's own reply already told the customer it was added; a failed background add here just means the drawer won't reflect it, not a second error message */
				});
		}

		function activateConversation(record) {
			stopPolling();
			active = record;
			setActiveLocalId(record.localId);
			renderActiveConversation();
			startPolling();
			renderHistoryList();
		}

		function startNewConversation() {
			var record = createConversationRecord();
			var list = loadConversations();
			list.push(record);
			saveConversations(list);
			activateConversation(record);
		}

		function switchToRemoteConversation(remote) {
			fetch(HISTORY_URL + '?conversationId=' + encodeURIComponent(remote.id) + '&anonymousId=' + encodeURIComponent(anonymousId))
				.then(function (res) {
					return res.ok ? res.json() : null;
				})
				.then(function (data) {
					if (!data || !data.messages) return;
					var record = createConversationRecord();
					record.conversationId = remote.id;
					record.label = remote.label ? truncateLabel(remote.label) : null;
					data.messages.forEach(function (m) {
						appendToConversationHistory(record, { role: m.role, text: m.content, staffName: m.staffName });
						if (m.id > record.lastMessageId) record.lastMessageId = m.id;
					});
					var list = loadConversations();
					list.push(record);
					saveConversations(list);
					activateConversation(record);
				})
				.catch(function () {
					/* leave the panel open — nothing to switch to yet */
				});
		}

		// `entry` is either a local record (has localId) or a remote-only row
		// the customer never actually opened on this device (no localId,
		// just a conversationId from the server list) — see
		// getHiddenConversationIds's own doc comment for why this only ever
		// hides, never really deletes, anything with a server conversationId.
		function deleteConversationEntry(entry) {
			if (entry.localId) {
				var list = loadConversations().filter(function (c) {
					return c.localId !== entry.localId;
				});
				saveConversations(list);
				if (entry.conversationId) hideConversationId(entry.conversationId);
				if (active.localId === entry.localId) {
					if (list.length) {
						activateConversation(
							list.slice().sort(function (a, b) {
								return b.updatedAt - a.updatedAt;
							})[0],
						);
					} else {
						startNewConversation();
					}
				} else {
					renderHistoryList();
				}
			} else if (entry.conversationId) {
				hideConversationId(entry.conversationId);
				renderHistoryList();
			}
		}

		function formatDate(value) {
			try {
				return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
			} catch (e) {
				return '';
			}
		}

		function renderHistoryList() {
			var hidden = getHiddenConversationIds();
			var localList = loadConversations();
			var rows = localList.map(function (c) {
				return {
					localId: c.localId,
					conversationId: c.conversationId,
					label: c.label || 'New conversation',
					date: formatDate(c.updatedAt),
					isActive: c.localId === active.localId,
				};
			});
			if (remoteConversations) {
				remoteConversations.forEach(function (remote) {
					if (hidden.indexOf(remote.id) !== -1) return;
					var alreadyLocal = localList.some(function (c) {
						return c.conversationId === remote.id;
					});
					if (alreadyLocal) return;
					rows.push({
						localId: null,
						conversationId: remote.id,
						label: remote.label ? truncateLabel(remote.label) : 'Conversation',
						date: formatDate(remote.lastMessageAt),
						isActive: false,
						remote: remote,
					});
				});
			}

			historyListEl.innerHTML = '';
			historyEmptyEl.hidden = rows.length > 0;
			rows.forEach(function (row) {
				var rowEl = document.createElement('div');
				rowEl.className = 'ai_chat_history_row' + (row.isActive ? ' is_active' : '');
				var textWrap = document.createElement('div');
				textWrap.className = 'ai_chat_history_row_text';
				var labelEl = document.createElement('span');
				labelEl.className = 'ai_chat_history_row_label';
				labelEl.textContent = row.label;
				var dateEl = document.createElement('span');
				dateEl.className = 'ai_chat_history_row_date';
				dateEl.textContent = row.date;
				textWrap.appendChild(labelEl);
				textWrap.appendChild(dateEl);
				var deleteBtn = document.createElement('button');
				deleteBtn.type = 'button';
				deleteBtn.className = 'ai_chat_history_row_delete';
				deleteBtn.setAttribute('aria-label', 'Delete conversation');
				deleteBtn.innerHTML = '<i class="fa-' + iconStyle + ' fa-trash" aria-hidden="true"></i>';
				rowEl.appendChild(textWrap);
				rowEl.appendChild(deleteBtn);
				textWrap.addEventListener('click', function () {
					if (row.localId) {
						var record = findLocalConversation(row.localId);
						if (record) activateConversation(record);
					} else if (row.remote) {
						switchToRemoteConversation(row.remote);
					}
					closeHistoryPanel();
				});
				deleteBtn.addEventListener('click', function (e) {
					e.stopPropagation();
					deleteConversationEntry(row);
				});
				historyListEl.appendChild(rowEl);
			});
		}

		// Opening the switcher replaces the chat view entirely (messages +
		// input hidden) rather than appending the list below it — direct
		// request (2026-08-10). Closing it (via the toggle again, Cancel, or
		// picking/adding a conversation) restores them.
		function closeHistoryPanel() {
			historyPanelEl.hidden = true;
			historyToggleBtn.setAttribute('aria-expanded', 'false');
			messagesEl.hidden = false;
			formEl.hidden = false;
		}

		function openHistoryPanel() {
			historyToggleBtn.setAttribute('aria-expanded', 'true');
			historyPanelEl.hidden = false;
			messagesEl.hidden = true;
			formEl.hidden = true;
			renderHistoryList();
			if (remoteConversations) return;
			fetch(CONVERSATIONS_URL)
				.then(function (res) {
					return res.ok ? res.json() : null;
				})
				.then(function (data) {
					if (!data || data.isGuest) return;
					remoteConversations = data.conversations || [];
					renderHistoryList();
				})
				.catch(function () {
					/* switcher still works from local data alone */
				});
		}

		function toggleHistoryPanel() {
			var expanded = historyToggleBtn.getAttribute('aria-expanded') === 'true';
			if (expanded) closeHistoryPanel();
			else openHistoryPanel();
		}

		function sendMessage(text) {
			sending = true;
			inputEl.value = '';
			sendBtn.disabled = true;

			addBubble('user').textContent = text;
			scrollToBottom(false);
			var localId = active.localId;
			var isFirstMessage = !active.conversationId;
			active =
				updateConversation(localId, function (record) {
					appendToConversationHistory(record, { role: 'user', text: text });
					if (!record.label) record.label = truncateLabel(text);
				}) || active;
			if (isFirstMessage) renderHistoryList();

			var assistantContent = addBubble('assistant');
			var assistantText = '';
			var pendingCartItems = [];

			fetch(MESSAGE_URL, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					conversationId: active.conversationId || null,
					message: text,
					anonymousId: anonymousId,
					currentProductId: currentProductId,
				}),
			})
				.then(function (res) {
					if (!res.ok || !res.body) throw new Error('HTTP ' + res.status);
					var reader = res.body.getReader();
					var decoder = new TextDecoder();
					var buffer = '';

					function pump() {
						return reader.read().then(function (chunk) {
							if (chunk.done) return;
							buffer += decoder.decode(chunk.value, { stream: true });
							var parsed = parseSseFrames(buffer);
							buffer = parsed.remainder;
							parsed.frames.forEach(function (frame) {
								if (frame.event === 'delta') {
									assistantText += frame.data.text;
									assistantContent.className = 'ai_chat_message_content';
									assistantContent.innerHTML = renderMarkdown(assistantText);
									scrollToBottom(false);
								} else if (frame.event === 'status') {
									if (!assistantText) {
										assistantContent.className = 'ai_chat_message_content ai_chat_status';
										assistantContent.textContent = frame.data.text + '…';
									}
								} else if (frame.event === 'done') {
									active =
										updateConversation(localId, function (record) {
											record.conversationId = frame.data.conversationId;
											appendToConversationHistory(record, { role: 'assistant', text: assistantText });
											if (frame.data.messageId && frame.data.messageId > record.lastMessageId) {
												record.lastMessageId = frame.data.messageId;
											}
										}) || active;
									startPolling();
									flushCartAdds(pendingCartItems);
								} else if (frame.event === 'cart_add') {
									pendingCartItems = pendingCartItems.concat(frame.data.cartPayload.items);
								} else if (frame.event === 'error') {
									assistantContent.className = 'ai_chat_message_content';
									assistantContent.textContent = 'Sorry, something went wrong: ' + frame.data.message;
								}
							});
							return pump();
						});
					}
					return pump();
				})
				.catch(function () {
					assistantContent.className = 'ai_chat_message_content';
					assistantContent.textContent = 'Connection error — please try again.';
				})
				.finally(function () {
					sending = false;
					sendBtn.disabled = !inputEl.value.trim();
				});
		}

		formEl.addEventListener('submit', function (e) {
			e.preventDefault();
			var text = inputEl.value.trim();
			if (!text || sending) return;
			sendMessage(text);
		});
		inputEl.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' && !e.shiftKey) {
				e.preventDefault();
				if (formEl.requestSubmit) formEl.requestSubmit();
				else formEl.dispatchEvent(new Event('submit', { cancelable: true }));
			}
		});
		inputEl.addEventListener('input', function () {
			sendBtn.disabled = Boolean(inputEl.disabled) || !inputEl.value.trim();
		});
		historyToggleBtn.addEventListener('click', toggleHistoryPanel);
		newConversationBtn.addEventListener('click', function () {
			startNewConversation();
			closeHistoryPanel();
		});
		historyCancelBtn.addEventListener('click', closeHistoryPanel);
		historyAddBtn.addEventListener('click', function () {
			startNewConversation();
			closeHistoryPanel();
		});

		renderActiveConversation();
		if (active.conversationId) startPolling();

		fetch(STATUS_URL)
			.then(function (res) {
				return res.ok ? res.json() : { enabled: false };
			})
			.then(function (data) {
				if (data.enabled) setAvailable(data.aiName);
				else setUnavailable();
			})
			.catch(setUnavailable);
	}

	function init() {
		var nodes = document.querySelectorAll('[data-ai-chat]');
		for (var i = 0; i < nodes.length; i++) initAiChat(nodes[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Some placements (e.g. this block dropped inside a Popup block) build
	// their contents on the fly rather than having them present at initial
	// page load — a plain querySelectorAll-at-load pass never finds those, so
	// their form/input never get bound and just sit there doing nothing. This
	// watches for any [data-ai-chat] element appearing anywhere, at any time,
	// so the block still initializes wherever/whenever it actually renders.
	// initAiChat's own root.__aiChatBound guard makes it safe to call twice on
	// the same element if both this and the pass above happen to see it.
	var aiChatObserver = new MutationObserver(function (mutations) {
		for (var i = 0; i < mutations.length; i++) {
			var added = mutations[i].addedNodes;
			for (var j = 0; j < added.length; j++) {
				var node = added[j];
				if (node.nodeType !== 1) continue;
				if (node.matches && node.matches('[data-ai-chat]')) initAiChat(node);
				if (node.querySelectorAll) {
					var nested = node.querySelectorAll('[data-ai-chat]');
					for (var k = 0; k < nested.length; k++) initAiChat(nested[k]);
				}
			}
		}
	});
	aiChatObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    // blocks/button.liquid
(function() {

	function queryByClassList(classListAttr) {
		if (!classListAttr) {
			return;
		}

		const selector = classListAttr.split(' ').filter(c => c).map(c => '.' + c).join('');
		return document.querySelectorAll(selector);
	}

	function syncTabState() {
		document.querySelectorAll('.block_button .tab').forEach(tab => {
			const isActive = tab.classList.contains('active');
			const targets = queryByClassList(tab.dataset.tab);

			tab.removeAttribute('role');
			tab.removeAttribute('aria-selected');
			tab.removeAttribute('aria-controls');
			tab.setAttribute('aria-expanded', isActive.toString());

			targets && targets.forEach(target => {
				target.classList.toggle('active', isActive);
				target.setAttribute('aria-hidden', (!isActive).toString());
				target.removeAttribute('role');
				target.removeAttribute('aria-labelledby');
			});
		});
	}

	function notifyAnimate() {
		window.dispatchEvent(new CustomEvent('active_animate'));
	}

	function trackClick(linkText, linkId, linkUrl) {
		if (typeof trackAnalyticsEvent === 'function') {
			trackAnalyticsEvent('click', { link_text: linkText || 'Unknown Button', link_id: linkId || 'button_interaction', link_url: linkUrl || window.location.pathname });
		} else if (window.gtag) {
			gtag('event', 'click', { link_text: linkText || 'Unknown Button', link_id: linkId || 'button_interaction', link_url: linkUrl || window.location.pathname });
		}
	}

	document.querySelectorAll('.block_button .tab').forEach(tab => {
		const buttonBlock = tab.closest('.block_button');

		if (buttonBlock && buttonBlock.parentNode) {
			const parentNode = buttonBlock.parentNode;

			parentNode.removeAttribute('role');
			parentNode.removeAttribute('aria-hidden');
			parentNode.removeAttribute('id');
			parentNode.removeAttribute('aria-labelledby');

			Array.from(parentNode.children).forEach(child => {
				child.classList.contains('block_button') && child.removeAttribute('role');
			});

			const activeTabs = Array.from(parentNode.children).filter(child => child.classList.contains('block_button')).map(child => child.querySelector('.tab.active')).filter(t => t);

			activeTabs.length > 1 && activeTabs.forEach((activeTab, index) => {
				index > 0 && activeTab.classList.remove('active');
			});
		}
	});

	syncTabState();
	notifyAnimate();

	document.addEventListener('click', event => {
		const clickedTab = event.target.closest('.block_button .tab');

		if (clickedTab) {
			if (clickedTab.classList.contains('active')) {
				return;
			}

			const tabGroup = clickedTab.closest('.block_column, .layout');

			if (tabGroup) {
				Array.from(tabGroup.children).filter(sibling => sibling.classList.contains('block_button')).forEach(sibling => {
					const siblingTab = sibling.querySelector('.tab');
					siblingTab && siblingTab.classList.remove('active');
				});
			}

			clickedTab.classList.add('active');
			syncTabState();
			notifyAnimate();
			trackClick(clickedTab.innerText, 'tab', clickedTab.dataset.tab);
			return;
		}

		const submitEl = event.target.closest('.block_button button[type="submit"][data-url],.block_button input[type="submit"][data-url]');

		if (!submitEl) {
			return;
		}

		const form = submitEl.closest('form');

		if (!form) {
			return;
		}

		event.preventDefault();

		const redirectUrl = submitEl.dataset.url;

		function submitViaIframe() {
			let iframe = document.getElementById('form_target');

			if (!iframe) {
				iframe = document.createElement('iframe');
				iframe.id = 'form_target';
				iframe.name = 'form_target';
				iframe.style.display = 'none';
				document.body.appendChild(iframe);
			}

			const originalText = submitEl.innerText;
			submitEl.innerText = 'Sent!';
			submitEl.disabled = true;
			form.target = 'form_target';
			form.submit();
			trackClick(originalText, 'submit', redirectUrl);

			setTimeout(() => {
				form.reset();
				submitEl.innerText = originalText;
				submitEl.disabled = false;
				iframe.parentNode && iframe.parentNode.removeChild(iframe);
			}, 1500);

			if (redirectUrl) {
				redirectUrl.startsWith('#')
					? document.dispatchEvent(new CustomEvent('popSlide', { detail: { id: redirectUrl } }))
					: setTimeout(() => location.href = redirectUrl, 500);
			}
		}

		if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
			window.Shopify.captcha.protect(form, submitViaIframe);
		} else if (window.hcaptcha && form.querySelector('.h-captcha')) {
			const widgetId = form.querySelector('.h-captcha').getAttribute('data-hcaptcha-widget-id');
			hcaptcha.execute(widgetId, { async: true }).then
				? hcaptcha.execute(widgetId, { async: true }).then(submitViaIframe)
				: hcaptcha.execute(widgetId, submitViaIframe);
		} else {
			submitViaIframe();
		}
	});

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    // blocks/countdown.liquid
	(function() {

		function initCountdowns() {
			const countdownBlocks = document.querySelectorAll('.block_countdown');

			countdownBlocks.forEach(countdown => {
				if (countdown.classList.contains('active')) {
					return;
				}

				const deadlineStr = countdown.getAttribute('data-deadline');
				const timezone = countdown.getAttribute('data-timezone') || 'UTC';
				const redirectUrl = countdown.getAttribute('data-url');
				const counterWrapper = countdown.querySelector('.counter_wrapper');
				const deadlineMsg = countdown.querySelector('.deadline_msg');

				function getDeadlineUtc(deadlineString, tz) {
					const [datePart, timePart] = deadlineString.split(' ');
					const [year, month, day] = datePart.split('-').map(Number);
					const [hour, minute] = timePart.split(':').map(Number);
					const naiveDate = new Date(year, month - 1, day, hour, minute);

					const formatter = new Intl.DateTimeFormat('en-US', {
						timeZone: tz,
						year: 'numeric', month: '2-digit', day: '2-digit',
						hour: '2-digit', minute: '2-digit', second: '2-digit',
						hour12: false
					});

					const parts = formatter.formatToParts(naiveDate);
					const partsMap = {};
					parts.forEach(part => partsMap[part.type] = part.value);

					const reinterpretedDate = new Date(`${partsMap.year}-${partsMap.month}-${partsMap.day}T${partsMap.hour}:${partsMap.minute}:${partsMap.second}`);
					const offsetCorrection = naiveDate.getTime() - reinterpretedDate.getTime();

					return naiveDate.getTime() + offsetCorrection;
				}

				const deadlineUtc = getDeadlineUtc(deadlineStr, timezone);
				let intervalId;

				function updateDisplay(container, days, hours, minutes, seconds) {
					const dayContainer = container.querySelector('.day_container');
					const secContainer = container.querySelector('.sec_container');
					const unitConfigs = [
						{ val: days, sel: '.day_container' },
						{ val: hours, sel: '.hr_container' },
						{ val: minutes, sel: '.min_container' },
						{ val: seconds, sel: '.sec_container' }
					];

					unitConfigs.forEach(unit => {
						const unitEl = container.querySelector(unit.sel);

						if (!unitEl) {
							return;
						}

						const counterEl = unitEl.querySelector('.counter');
						const pluralEl = unitEl.querySelector('.label .plural');

						if (counterEl) {
							counterEl.textContent = unit.val;
						}

						if (pluralEl) {
							unit.val === 1 ? pluralEl.classList.add('hidden') : pluralEl.classList.remove('hidden');
						}
					});

					if (days > 0) {
						if (secContainer) secContainer.classList.add('hidden');
						if (dayContainer) dayContainer.classList.remove('hidden');
					} else {
						if (secContainer) secContainer.classList.remove('hidden');
						if (dayContainer) dayContainer.classList.add('hidden');
					}
				}

				function updateCountdown() {
					const nowMs = Date.now();
					const remaining = deadlineUtc - nowMs;

					if (remaining <= 0) {
						if (intervalId) {
							clearInterval(intervalId);
						}

						updateDisplay(countdown, 0, 0, 0, 0);

						if (redirectUrl) {
							if (redirectUrl.startsWith('#')) {
								const triggerRedirect = () => {
									countdown.dispatchEvent(new CustomEvent('popSlide', { bubbles: true, detail: { id: redirectUrl } }));
								};

								if (document.readyState === 'complete') {
									triggerRedirect();
								} else {
									window.addEventListener('load', triggerRedirect, { once: true });
								}
							} else {
								window.location.href = redirectUrl;
							}

							return;
						}

						if (deadlineMsg) {
							deadlineMsg.classList.remove('hidden');
							if (counterWrapper) {
								counterWrapper.classList.add('hidden');
							}
						}

						return;
					}

					const days = Math.floor(remaining / 86400000);
					const hours = Math.floor(remaining % 86400000 / 3600000);
					const minutes = Math.floor(remaining % 3600000 / 60000);
					const seconds = Math.floor(remaining % 60000 / 1000);

					updateDisplay(countdown, days, hours, minutes, seconds);
				}

				updateCountdown();

				if (deadlineUtc - Date.now() > 0) {
					intervalId = setInterval(() => {
						document.body.contains(countdown) ? updateCountdown() : clearInterval(intervalId);
					}, 1000);
				}

				countdown.classList.add('active');
			});
		}

		initCountdowns();
		document.addEventListener('shopify:block:select', initCountdowns);
		document.addEventListener('shopify:block:deselect', initCountdowns);

	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // blocks/filters.liquid
	// Note: This filter script is designed to integrate with GA4 using a custom event called "filter_applied", passing a filter_type attribute you can build reports out of
	class FilterForm {
		static async submit(filterEl, overrideUrl = null) {
			if (!filterEl.classList.contains('dynamic')) {
				return;
			}

			if (window.filterAbortController) {
				window.filterAbortController.abort();
			}

			window.filterAbortController = new AbortController();

			const form = filterEl.tagName === 'FORM' ? filterEl : filterEl.querySelector('form');
			let formData;

			if (form) {
				formData = new FormData(form);
			} else {
				formData = new FormData();
				filterEl.querySelectorAll('input, select, textarea').forEach(input => {
					if (input.name && !input.disabled && (input.type !== 'checkbox' && input.type !== 'radio' || input.checked)) {
						formData.append(input.name, input.value);
					}
				});
			}

			const sortInput = filterEl.querySelector('[name="sort_by"]');

			if (sortInput) {
				const isSelect = sortInput.tagName === 'SELECT';
				const isDisabled = isSelect ? sortInput.options[sortInput.selectedIndex]?.hasAttribute('data-disabled') : sortInput.hasAttribute('data-disabled');

				if (isDisabled) {
					formData.delete('sort_by');
				}
			}

			const priceContainer = filterEl.querySelector('.price_range_container');

			if (priceContainer) {
				const minLimit = parseFloat(priceContainer.dataset.min);
				const maxLimit = parseFloat(priceContainer.dataset.max);
				const minInputName = priceContainer.querySelector('.min_price').dataset.input;
				const maxInputName = priceContainer.querySelector('.max_price').dataset.input;

				filterEl.querySelectorAll('.price_range_container input[type="hidden"]').forEach(hiddenInput => {
					const value = parseFloat(hiddenInput.value);

					if (hiddenInput.name === minInputName) {
						value === minLimit ? formData.delete(minInputName) : formData.set(minInputName, hiddenInput.value);
					}

					if (hiddenInput.name === maxInputName) {
						value === maxLimit ? formData.delete(maxInputName) : formData.set(maxInputName, hiddenInput.value);
					}
				});
			}

			const queryString = new URLSearchParams(formData).toString();
			const formAction = (form ? form.action : null) || window.location.pathname;
			const targetUrl = overrideUrl || (queryString ? `${formAction}?${queryString}` : formAction);
			const section = filterEl.closest('.shopify-section');

			if (!section || !section.querySelector('.block_card')) {
				window.location.href = targetUrl;
				return;
			}

			const sectionIds = [section.id].filter(Boolean);

			try {
				const response = await fetch(targetUrl, { signal: window.filterAbortController.signal });
				const responseText = await response.text();
				const parsedDoc = new DOMParser().parseFromString(responseText, 'text/html');

				sectionIds.forEach(id => {
					const liveEl = document.getElementById(id);
					const newEl = parsedDoc.getElementById(id);

					if (liveEl && newEl) {
						liveEl.outerHTML = newEl.outerHTML;
					}
				});

				document.querySelectorAll('.block_filters.dynamic[id]').forEach(dynamicFilterEl => {
					const newFilterEl = parsedDoc.getElementById(dynamicFilterEl.id);

					if (newFilterEl) {
						dynamicFilterEl.outerHTML = newFilterEl.outerHTML;
					}
				});

				window.history.replaceState(null, '', targetUrl);
				initSliders();
			} catch (error) {
				if (error.name !== 'AbortError') {
					console.error(error);
					filterEl.querySelectorAll('.loading').forEach(el => el.classList.remove('loading'));
					section.style.opacity = '';
				}
			}
		}
	}

	document.addEventListener('change', e => {
		const filterEl = e.target.closest('.block_filters.dynamic');

		if (!filterEl) {
			return;
		}

		if (e.target.type === 'checkbox' || e.target.name === 'sort_by' || e.target.type === 'radio') {
			if (e.target.type === 'checkbox' || e.target.type === 'radio') {
				e.target.closest('.filter_value')?.classList.add('loading');
			}

			if (e.target.name === 'sort_by') {
				const section = filterEl.closest('.shopify-section');

				if (section) {
					section.style.opacity = '0.5';
				}
			}

			FilterForm.submit(filterEl);
		}
	});

	document.addEventListener('submit', e => {
		const filterEl = e.target.closest('.block_filters.dynamic');

		if (filterEl) {
			e.preventDefault();
			FilterForm.submit(filterEl);
		}
	});

	document.addEventListener('click', e => {
		const resetLink = e.target.closest('.reset_filter');

		if (!resetLink) {
			return;
		}

		const filterEl = resetLink.closest('.block_filters.dynamic');

		if (!filterEl) {
			return;
		}

		e.preventDefault();

		const form = filterEl.tagName === 'FORM' ? filterEl : filterEl.querySelector('form');
		const baseUrl = (form ? form.action : null) || window.location.pathname;
		const sortInput = filterEl.querySelector('[name="sort_by"]');
		let resetUrl = baseUrl;

		if (sortInput && sortInput.value) {
			const isSelect = sortInput.tagName === 'SELECT';
			const isDisabled = isSelect ? sortInput.options[sortInput.selectedIndex]?.hasAttribute('data-disabled') : sortInput.hasAttribute('data-disabled');

			if (!isDisabled) {
				resetUrl += (resetUrl.includes('?') ? '&' : '?') + `sort_by=${sortInput.value}`;
			}
		}

		FilterForm.submit(filterEl, resetUrl);
	});

	class PriceRangeSlider {
		constructor(container) {
			if (container._sliderInit) {
				return;
			}

			container._sliderInit = true;
			this.container = container;
			this.minBtn = container.querySelector('.min_price');
			this.maxBtn = container.querySelector('.max_price');
			this.rangeBar = container.querySelector('.price_range_slider_range');
			this.track = container.querySelector('.price_range_slider');
			this.minLimit = parseFloat(container.dataset.min);
			this.maxLimit = parseFloat(container.dataset.max);
			this.step = parseFloat(container.dataset.step);
			this.currency = container.dataset.currency;
			this.init();
		}

		init() {
			const startDrag = (event, handle) => {
				event.preventDefault();
				event.stopPropagation();
				document.body.style.userSelect = 'none';

				const otherHandle = handle === this.minBtn ? this.maxBtn : this.minBtn;
				otherHandle.style.opacity = '0.2';

				const onMove = moveEvent => {
					const clientX = moveEvent.touches ? moveEvent.touches[0].clientX : moveEvent.clientX;
					this.handleMove(clientX, handle);
				};

				const onRelease = () => {
					document.body.style.userSelect = '';
					document.removeEventListener('mousemove', onMove);
					document.removeEventListener('mouseup', onRelease);
					document.removeEventListener('touchmove', onMove);
					document.removeEventListener('touchend', onRelease);

					otherHandle.style.opacity = '';

					const filterEl = this.container.closest('.block_filters.dynamic');

					if (filterEl) {
						handle.classList.add('loading');
						FilterForm.submit(filterEl);
					}
				};

				document.addEventListener('mousemove', onMove);
				document.addEventListener('mouseup', onRelease);
				document.addEventListener('touchmove', onMove, { passive: false });
				document.addEventListener('touchend', onRelease);
			};

			[this.minBtn, this.maxBtn].forEach(handle => {
				handle.setAttribute('tabindex', '0');
				handle.style.touchAction = 'none';
				handle.addEventListener('mousedown', event => startDrag(event, handle));
				handle.addEventListener('touchstart', event => startDrag(event, handle), { passive: false });
				handle.addEventListener('keydown', keyEvent => {
					if (keyEvent.key === 'ArrowLeft' || keyEvent.key === 'ArrowRight') {
						keyEvent.preventDefault();

						const input = this.container.querySelector(`input[name="${handle.dataset.input}"]`);
						const newValue = parseFloat(input.value) + (keyEvent.key === 'ArrowLeft' ? -this.step : this.step);
						this.updateValue(handle, newValue);

						const filterEl = this.container.closest('.block_filters.dynamic');

						if (filterEl) {
							clearTimeout(this.kbTimeout);
							this.kbTimeout = setTimeout(() => {
								handle.classList.add('loading');
								FilterForm.submit(filterEl);
							}, 500);
						}
					}
				});
			});

			this.track.addEventListener('click', event => {
				if (event.target.closest('.min_price') || event.target.closest('.max_price')) {
					return;
				}

				const trackRect = this.track.getBoundingClientRect();
				const clickRatio = (event.clientX - trackRect.left) / trackRect.width;
				const rawValue = Math.round((this.minLimit + clickRatio * (this.maxLimit - this.minLimit)) / this.step) * this.step;
				const currentMin = parseFloat(this.container.querySelector(`input[name="${this.minBtn.dataset.input}"]`).value);
				const currentMax = parseFloat(this.container.querySelector(`input[name="${this.maxBtn.dataset.input}"]`).value);
				let targetHandle = null;

				if (rawValue < currentMin) {
					targetHandle = this.minBtn;
				} else if (rawValue > currentMax) {
					targetHandle = this.maxBtn;
				} else {
					targetHandle = Math.abs(rawValue - currentMin) < Math.abs(rawValue - currentMax) ? this.minBtn : this.maxBtn;
				}

				if (targetHandle) {
					this.updateValue(targetHandle, rawValue);

					const filterEl = this.container.closest('.block_filters.dynamic');

					if (filterEl) {
						targetHandle.classList.add('loading');
						FilterForm.submit(filterEl);
					}
				}
			});

			this.refreshUI();
		}

		handleMove(clientX, handle) {
			const trackRect = this.track.getBoundingClientRect();
			const ratio = (clientX - trackRect.left) / trackRect.width;
			const newValue = Math.round((this.minLimit + ratio * (this.maxLimit - this.minLimit)) / this.step) * this.step;
			this.updateValue(handle, newValue);
		}

		updateValue(handle, rawValue) {
			const isMin = handle === this.minBtn;
			let value = Math.max(this.minLimit, Math.min(this.maxLimit, rawValue));
			const minInput = this.container.querySelector(`input[name="${this.minBtn.dataset.input}"]`);
			const maxInput = this.container.querySelector(`input[name="${this.maxBtn.dataset.input}"]`);

			if (isMin) {
				if (value >= parseFloat(maxInput.value)) {
					value = parseFloat(maxInput.value) - this.step;
				}

				minInput.value = value;
			} else {
				if (value <= parseFloat(minInput.value)) {
					value = parseFloat(minInput.value) + this.step;
				}

				maxInput.value = value;
			}

			handle.querySelector('span').textContent = `${this.currency}${Math.round(value)}`;
			this.refreshUI();
		}

		refreshUI() {
			const minInput = this.container.querySelector(`input[name="${this.minBtn.dataset.input}"]`);
			const maxInput = this.container.querySelector(`input[name="${this.maxBtn.dataset.input}"]`);

			if (!minInput || !maxInput) {
				return;
			}

			const minValue = parseFloat(minInput.value);
			const maxValue = parseFloat(maxInput.value);
			const range = this.maxLimit - this.minLimit;
			const minPercent = (minValue - this.minLimit) / range * 100;
			const maxPercent = (maxValue - this.minLimit) / range * 100;

			this.minBtn.style.left = `${minPercent}%`;
			this.maxBtn.style.left = `${maxPercent}%`;
			this.rangeBar.style.left = `${minPercent}%`;
			this.rangeBar.style.width = `${maxPercent - minPercent}%`;
		}
	}

	function initSliders() {
		document.querySelectorAll('.block_filters.dynamic .price_range_container').forEach(container => new PriceRangeSlider(container));
	}

	initSliders();

	const observer = new MutationObserver(mutations => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (node.nodeType === 1) {
					if (node.matches('.price_range_container')) {
						new PriceRangeSlider(node);
					} else {
						node.querySelectorAll('.price_range_container').forEach(el => new PriceRangeSlider(el));
					}
				}
			}
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gallery"] && !Shopify.designMode) return;
  try {
    // blocks/gallery.liquid
	function initCarousel(selector) {

		let resizeTimeout;

		function syncHeight(container, activeSlide, immediate) {
			clearTimeout(resizeTimeout);

			const newHeight = activeSlide.getBoundingClientRect().height;
			const currentHeight = container.getBoundingClientRect().height;
			const applyHeight = () => {
				container.style.height = `${newHeight}px`;
			};

			if (newHeight > currentHeight || immediate) {
				applyHeight();
			} else {
				resizeTimeout = setTimeout(applyHeight, 500);
			}
		}

		const observer = new ResizeObserver(entries => {
			for (const entry of entries) {
				const container = entry.target.parentElement;

				if (container && entry.target.classList.contains('active')) {
					syncHeight(container, entry.target, false);
				}
			}
		});

		document.querySelectorAll(selector).forEach(container => {
			const slides = Array.from(container.children).filter(el => el.tagName === 'DIV' && !el.classList.contains('gallery_nav_arrow'));

			if (!slides.length) {
				return;
			}

			function activate(newSlide, oldSlide) {
				if (oldSlide) {
					oldSlide.classList.remove('active');
					observer.unobserve(oldSlide);
				}

				newSlide.classList.add('active');
				observer.observe(newSlide);
				syncHeight(container, newSlide, false);
			}

			const initialSlide = container.querySelector('.active') || slides[0];
			activate(initialSlide);
			container.style.height = `${initialSlide.getBoundingClientRect().height}px`;

			container.addEventListener('click', e => {
				const arrow = e.target.closest('.gallery_nav_arrow');

				if (!arrow) {
					return;
				}

				const direction = parseInt(arrow.getAttribute('data-direction'));
				const currentSlide = container.querySelector('.active');
				const nextIndex = (slides.indexOf(currentSlide) + direction + slides.length) % slides.length;

				activate(slides[nextIndex], currentSlide);
			});

			container.classList.add('loaded');
		});
	}

	function runCarousel() {
		initCarousel('.block_gallery.block');
	}

	document.addEventListener('shopify:section:load', runCarousel);
	runCarousel();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-navigator"] && !Shopify.designMode) return;
  try {
    // blocks/image-navigator.liquid
document.addEventListener('click', e => {
	if (window.innerWidth >= 768) {
		return;
	}

	const pin = e.target.closest('.block_image_navigator_pin');
	const closeBtn = e.target.closest('.close_btn');

	if (closeBtn) {
		e.preventDefault();
		e.stopPropagation();

		const activePin = closeBtn.closest('.block_image_navigator_pin');

		if (activePin) {
			activePin.classList.remove('active');
		}

		return;
	}

	if (pin && !pin.classList.contains('active')) {
		e.preventDefault();
		pin.classList.add('active');
	}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["map"] && !Shopify.designMode) return;
  try {
    // blocks/map.liquid
	!function () {
		const callbackName = `initMaps${Date.now()}`;

		window[callbackName] = function () {
			function initMapBlock(blockEl) {
				const wrapper = blockEl.querySelector('.map_warpper');
				const mapEl = blockEl.querySelector('.map');

				if (!mapEl || !wrapper) {
					console.error(`Map element (.map) or wrapper (.map_warpper) not found within block: ${blockEl.id}`);
					return;
				}

				const markersUrl = mapEl.dataset.markers;
				const markerColor = getComputedStyle(wrapper).getPropertyValue('--marker_color').trim();
				const errorColor = getComputedStyle(wrapper).getPropertyValue('--error_color').trim();
				const alertColor = getComputedStyle(wrapper).getPropertyValue('--alert_color').trim();
				const loadingContainer = blockEl.querySelector('.loading_container');
				const msgContainer = blockEl.querySelector('.msg_container');
				const msgEl = blockEl.querySelector('.msg');
				const addressInput = blockEl.querySelector('.address_input');
				const geoBtn = blockEl.querySelector('.geo_btn');
				const clearBtn = blockEl.querySelector('.clear_btn');

				let map;
				let locations = [];
				let directionsService;
				let directionsRenderer;
				let markers = [];
				let infoWindow;
				let autocomplete;

				function showLoading() {
					if (loadingContainer) {
						loadingContainer.style.opacity = '1';
						loadingContainer.style.pointerEvents = 'auto';
					}
				}

				function hideLoading() {
					if (loadingContainer) {
						loadingContainer.style.opacity = '0';
						loadingContainer.style.pointerEvents = 'none';
					}
				}

				function showMessage(text, isError = true) {
					if (msgEl && msgContainer) {
						msgEl.textContent = text;
						msgContainer.style.opacity = '1';
						msgContainer.style.pointerEvents = 'auto';
						msgContainer.style.backgroundColor = isError ? errorColor : alertColor;
						setTimeout(() => {
							msgContainer.style.opacity = '0';
							msgContainer.style.pointerEvents = 'none';
						}, 5000);
					} else {
						console.warn('Could not display message box: ', text);
					}
				}

				function updateGeoClearButtons() {
					if (geoBtn && clearBtn && addressInput) {
						if (addressInput.value.trim() === '') {
							geoBtn.classList.remove('hidden');
							clearBtn.classList.add('hidden');
						} else {
							geoBtn.classList.add('hidden');
							clearBtn.classList.remove('hidden');
						}
					}
				}

				function clearMarkers() {
					for (let i = 0; i < markers.length; i++) {
						if (markers[i].map) {
							markers[i].map = null;
						}
					}

					markers = [];
				}

				function createIconElement(iconUrl) {
					const container = document.createElement('div');
					container.style.width = '32px';
					container.style.height = '32px';
					container.style.position = 'relative';

					const img = document.createElement('img');
					img.src = iconUrl;
					img.style.width = '100%';
					img.style.height = '100%';
					img.style.objectFit = 'contain';
					img.style.position = 'absolute';
					img.style.top = '100%';
					img.style.left = '50%';
					img.style.transform = 'translate(-50%, -100%)';
					container.appendChild(img);

					return container;
				}

				function createPin(glyph, color = markerColor) {
					const pin = new google.maps.marker.PinElement({ background: color, borderColor: '#FFFFFF', glyph });
					return pin.element;
				}

				function plotMarkers(locationsList) {
					if (directionsRenderer) {
						directionsRenderer.setMap(null);
					}

					clearMarkers();

					const iconUrl = mapEl.dataset.markerIconUrl;

					locationsList.forEach(location => {
						const name = location.Name;
						const lat = parseFloat(location.Latitude);
						const lng = parseFloat(location.Longitude);

						if (name && !isNaN(lat) && !isNaN(lng)) {
							let content;
							content = iconUrl ? createIconElement(iconUrl) : createPin('');

							const marker = new google.maps.marker.AdvancedMarkerElement({
								position: { lat, lng },
								map,
								title: name,
								content
							});

							markers.push(marker);
							marker.addEventListener('click', () => {
								const infoContent = buildInfoWindowContent(location);
								infoWindow.setContent(infoContent);
								infoWindow.open(map, marker);
							});
						}
					});
				}

				function routeAndShowDirections(origin, destination, destinationName, infoWindowContent) {
					const iconUrl = mapEl.dataset.markerIconUrl;
					const startIconDataUri = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M376 88C376 57.1 350.9 32 320 32C289.1 32 264 57.1 264 88C264 118.9 289.1 144 320 144C350.9 144 376 118.9 376 88zM400 300.7L446.3 363.1C456.8 377.3 476.9 380.3 491.1 369.7C505.3 359.1 508.3 339.1 497.7 324.9L427.2 229.9C402 196 362.3 176 320 176C277.7 176 238 196 212.8 229.9L142.3 324.9C131.8 339.1 134.7 359.1 148.9 369.7C163.1 380.3 183.1 377.3 193.7 363.1L240 300.7L240 576C240 593.7 254.3 608 272 608C289.7 608 304 593.7 304 576L304 416C304 407.2 311.2 400 320 400C328.8 400 336 407.2 336 416L336 576C336 593.7 350.3 608 368 608C385.7 608 400 593.7 400 576L400 300.7z"/></svg>'.replace(/fill\s*=\s*("|').*?("|')/g, '').replace('<path d', '<path fill="' + (markerColor || '#000000') + '" d'));

					directionsService.route({ origin, destination, travelMode: 'DRIVING' }, (directionsResult, status) => {
						hideLoading();

						if (status === 'OK') {
							directionsRenderer.setMap(map);
							directionsRenderer.setDirections(directionsResult);

							const destinationContent = iconUrl ? createIconElement(iconUrl) : createPin('');
							const destinationMarker = new google.maps.marker.AdvancedMarkerElement({
								position: destination,
								map,
								title: destinationName,
								content: destinationContent
							});
							markers.push(destinationMarker);

							const startImg = document.createElement('img');
							startImg.src = startIconDataUri;
							startImg.style.width = '32px';
							startImg.style.height = '32px';
							startImg.style.transform = 'translateY(-50%)';

							const startMarker = new google.maps.marker.AdvancedMarkerElement({
								position: origin,
								map,
								title: 'Your Starting Point',
								content: startImg
							});
							markers.push(startMarker);

							if (infoWindowContent) {
								infoWindow.setContent(infoWindowContent);
								infoWindow.open(map, destinationMarker);
							}

							showMessage(`Directions to the nearest location: ${destinationName}`, false);
						} else {
							console.error('Directions request failed due to ' + status);
							showMessage(`Failed to get directions to ${destinationName}. Please try a different starting point.`, true);
							plotMarkers(locations);
						}
					});
				}

				function routeToNearestLocation(geocodeRequest) {
					showLoading();
					clearMarkers();

					const geocoder = new google.maps.Geocoder();

					geocoder.geocode(geocodeRequest, (geocodeResults, geocodeStatus) => {
						if (geocodeStatus === 'OK') {
							const originLocation = geocodeResults[0].geometry.location;
							let nearestLocation = null;
							let nearestDistance = Infinity;

							locations.forEach(location => {
								const lat = parseFloat(location.Latitude);
								const lng = parseFloat(location.Longitude);

								if (!isNaN(lat) && !isNaN(lng)) {
									const latLng = new google.maps.LatLng(lat, lng);
									const distance = google.maps.geometry.spherical.computeDistanceBetween(originLocation, latLng);

									if (distance < nearestDistance) {
										nearestDistance = distance;
										nearestLocation = location;
									}
								}
							});

							if (nearestLocation) {
								const nearestLatLng = new google.maps.LatLng(parseFloat(nearestLocation.Latitude), parseFloat(nearestLocation.Longitude));
								const infoContent = buildInfoWindowContent(nearestLocation);
								routeAndShowDirections(originLocation, nearestLatLng, nearestLocation.Name, infoContent);
							} else {
								const hasDefaultMarker = mapEl.dataset.defaultMarker === 'true';
								const defaultLat = parseFloat(mapEl.dataset.lat);
								const defaultLng = parseFloat(mapEl.dataset.lng);

								if (!hasDefaultMarker || isNaN(defaultLat) || isNaN(defaultLng)) {
									hideLoading();
									showMessage('Could not find any valid locations to route to.', true);
									plotMarkers(locations);
								} else {
									const defaultLatLng = new google.maps.LatLng(defaultLat, defaultLng);
									routeAndShowDirections(originLocation, defaultLatLng, 'Default Location', null);
								}
							}
						} else {
							hideLoading();
							console.error('Geocode was not successful for the following reason: ' + geocodeStatus);
							showMessage('The entered location could not be found. Please try a different address.', true);
							plotMarkers(locations);
						}
					});
				}

				function buildInfoWindowContent(location) {
					let html = '<div class="font-sans p-2">';

					if (location.Image) {
						html += `<img src="${location.Image}" style="max-width:20em;width:100%;height:auto;border-radius:4px;margin-bottom:8px;" alt="${location.Name} image">`;
					}

					html += `<h2 class="text-lg font-bold">${location.Name}</h2>`;

					if (location.Address) {
						const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.Address)}`;
						html += `<p class="text-sm text-gray-600">Address: <a href="${mapsUrl}" target="_blank" class="text-blue-600 hover:underline">${location.Address}</a></p>`;
					}

					if (location.Phone) {
						html += `<p class="text-sm text-gray-600">Phone: <a href="tel:${location.Phone}" class="text-blue-600 hover:underline">${location.Phone}</a></p>`;
					}

					if (location.Website) {
						const websiteUrl = location.Website.startsWith('http') ? location.Website : `http://${location.Website}`;
						html += `<p class="text-sm text-gray-600">Website: <a href="${websiteUrl}" target="_blank" class="text-blue-600 hover:underline">${location.Website}</a></p>`;
					}

					return html + '</div>';
				}

				function initMap(center, zoom) {
					map = new google.maps.Map(mapEl, { zoom, center, mapId: 'STORES_ID' });
					infoWindow = new google.maps.InfoWindow();
					directionsService = new google.maps.DirectionsService();
					directionsRenderer = new google.maps.DirectionsRenderer({
						map,
						suppressMarkers: true,
						polylineOptions: { strokeColor: markerColor, strokeWeight: 5 }
					});

					if (addressInput) {
						autocomplete = new google.maps.places.Autocomplete(addressInput, { fields: ['geometry', 'formatted_address'] });
						autocomplete.addListener('place_changed', () => {
							const place = autocomplete.getPlace();

							if (place.geometry) {
								addressInput.value = place.formatted_address;
								routeToNearestLocation({ location: place.geometry.location });
								updateGeoClearButtons();
							}
						});

						addressInput.addEventListener('keypress', e => {
							if (e.key === 'Enter') {
								e.preventDefault();

								const query = addressInput.value.trim();

								if (query === '') {
									showMessage('Please enter an address to search.', false);
									return;
								}

								routeToNearestLocation({ address: query });
							}
						});

						updateGeoClearButtons();
						addressInput.addEventListener('keyup', updateGeoClearButtons);
					}

					if (markersUrl) {
						showLoading();

						if (typeof Papa === 'undefined') {
							hideLoading();
							showMessage('Mapping data library failed to load.', true);
							return;
						}

						Papa.parse(markersUrl, {
							download: true,
							header: true,
							complete: function(parseResult) {
								hideLoading();

								if (parseResult.data.length > 0) {
									try {
										locations = parseResult.data.filter(row => row.Name && !isNaN(parseFloat(row.Latitude)) && !isNaN(parseFloat(row.Longitude)));

										if (locations.length === 0) {
											showMessage('Loaded data but found no valid locations with coordinates.', true);
											return;
										}

										plotMarkers(locations);
									} catch (parseError) {
										console.error('Error processing data:', parseError);
										showMessage('An error occurred while processing the spreadsheet data.');
									}
								} else {
									showMessage('No data found in the spreadsheet.', true);
								}
							},
							error: function(fetchError) {
								hideLoading();
								console.error('Error fetching or parsing CSV:', fetchError);
								showMessage('Failed to load spreadsheet data. Check the URL or your network connection.', true);
							}
						});
					}

					const hasDefaultMarker = mapEl.dataset.defaultMarker === 'true';

					if (hasDefaultMarker) {
						const lat = parseFloat(mapEl.dataset.lat);
						const lng = parseFloat(mapEl.dataset.lng);
						const iconUrl = mapEl.dataset.markerIconUrl;

						if (!isNaN(lat) && !isNaN(lng)) {
							const content = iconUrl ? createIconElement(iconUrl) : createPin('');
							new google.maps.marker.AdvancedMarkerElement({ position: { lat, lng }, map, content });
						}
					}

					if (!markersUrl) {
						hideLoading();
					}
				}

				geoBtn && geoBtn.addEventListener('click', () => {
					showLoading();

					if (navigator.geolocation) {
						navigator.geolocation.getCurrentPosition(position => {
							const coords = { lat: position.coords.latitude, lng: position.coords.longitude };
							const geocoder = new google.maps.Geocoder();

							geocoder.geocode({ location: coords }, (geoResults, geoStatus) => {
								if (geoStatus === 'OK' && geoResults[0] && addressInput) {
									addressInput.value = geoResults[0].formatted_address;
									updateGeoClearButtons();
								}

								routeToNearestLocation({ location: coords });
							});
						}, error => {
							hideLoading();
							showMessage(error.code === error.PERMISSION_DENIED ? 'Geolocation permission denied. Please enable location services in your browser settings.' : 'Geolocation failed. Please try again.', true);
						});
					} else {
						hideLoading();
						showMessage('Your browser does not support geolocation.', true);
					}
				});

				clearBtn && clearBtn.addEventListener('click', () => {
					if (addressInput) {
						addressInput.value = '';
					}

					if (directionsRenderer) {
						directionsRenderer.setMap(null);
					}

					clearMarkers();

					const defaultLat = parseFloat(mapEl.dataset.lat);
					const defaultLng = parseFloat(mapEl.dataset.lng);
					const defaultZoom = parseInt(mapEl.dataset.zoom, 10);

					if (map) {
						map.setCenter({ lat: defaultLat, lng: defaultLng });
						map.setZoom(defaultZoom);
					}

					plotMarkers(locations);
					updateGeoClearButtons();
					showMessage('Map has been reset.', false);
				});

				const centerOnGeolocation = mapEl.dataset.centerOnGeolocation === 'true';

				if (centerOnGeolocation && navigator.geolocation) {
					showLoading();
					navigator.geolocation.getCurrentPosition(position => {
						const coords = { lat: position.coords.latitude, lng: position.coords.longitude };
						const zoom = parseInt(mapEl.dataset.zoom, 10);
						initMap(coords, zoom);
					}, () => {
						hideLoading();
						const fallbackCenter = { lat: parseFloat(mapEl.dataset.lat), lng: parseFloat(mapEl.dataset.lng) };
						const fallbackZoom = parseInt(mapEl.dataset.zoom, 10);
						initMap(fallbackCenter, fallbackZoom);
					});
				} else {
					const fallbackCenter = { lat: parseFloat(mapEl.dataset.lat), lng: parseFloat(mapEl.dataset.lng) };
					const fallbackZoom = parseInt(mapEl.dataset.zoom, 10);
					initMap(fallbackCenter, fallbackZoom);
				}
			}

			const mapBlocks = document.querySelectorAll('.block_map');
			mapBlocks.forEach(blockEl => {
				initMapBlock(blockEl);
			});
		};

		const papaScript = document.createElement('script');
		papaScript.src = 'https://unpkg.com/papaparse@5.4.1/papaparse.min.js';
		papaScript.async = true;
		document.head.appendChild(papaScript);

		const mapsScript = document.createElement('script');
		mapsScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDZP9YmSyHP5lfBa-5MoeznmaClXtYJTVs&callback=${callbackName}&libraries=places,geometry,marker&loading=async`;
		mapsScript.async = true;
		mapsScript.onerror = () => {
			console.error('Failed to load Google Maps API script. Please check your API key.');
		};
		document.head.appendChild(mapsScript);
	}();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["navigation"] && !Shopify.designMode) return;
  try {
    // blocks/navigation.liquid
	document.addEventListener('DOMContentLoaded', async () => {
		const now = Date.now();
		const cacheLife = 3600000;
		const links = Array.from(document.querySelectorAll('.block_nav li.type_collection_link > a'));
		const tocContainer = document.querySelector('.block_nav.hashtag');
		const main = document.querySelector('main');

		if (tocContainer && main) {
			const headings = Array.from(main.querySelectorAll('h2[id], h3[id]')).filter(h => !h.classList.contains('sr_only') && !h.closest('.sr_only'));
			const mainUl = document.createElement('ul');

			if (headings.length > 0) {
				let lastH2Li = null;
				let currentSubUl = null;

				headings.forEach(h => {
					const li = document.createElement('li');
					const a = document.createElement('a');
					a.href = `#${h.id}`;
					a.textContent = h.textContent.trim();
					li.appendChild(a);

					if (h.tagName === 'H2') {
						mainUl.appendChild(li);
						lastH2Li = li;
						currentSubUl = null;
					} else if (h.tagName === 'H3') {
						if (!currentSubUl) {
							currentSubUl = document.createElement('ul');
							(lastH2Li || mainUl).appendChild(currentSubUl);
						}

						currentSubUl.appendChild(li);
					}
				});

				tocContainer.innerHTML = '';
				tocContainer.appendChild(mainUl);
			} else {
				const emptyDiv = document.createElement('div');
				tocContainer.replaceWith(emptyDiv);
			}
		}

		for (const link of links) {
			const url = link.getAttribute('href');
			const cached = JSON.parse(sessionStorage.getItem(url));

			if (cached && (now - cached.time < cacheLife)) {
				if (cached.status === 'hidden') {
					const li = link.closest('li.type_collection_link');
					if (li) {
						li.style.display = 'none';
					}
				}

				continue;
			}

			try {
				const res = await fetch(url);
				const text = await res.text();
				const doc = new DOMParser().parseFromString(text, 'text/html');
				const script = doc.getElementById('json_ld');
				let hasProducts = false;

				if (script) {
					try {
						const data = JSON.parse(script.textContent);
						const graph = Array.isArray(data) ? data : (data['@graph'] || [data]);
						hasProducts = graph.some(item => item['@type'] === 'ItemList' && item.itemListElement?.length > 0);
					} catch (error) {}
				}

				if (!hasProducts) {
					sessionStorage.setItem(url, JSON.stringify({ status: 'hidden', time: now }));
					const li = link.closest('li.type_collection_link');
					if (li) {
						li.style.display = 'none';
					}
				} else {
					sessionStorage.setItem(url, JSON.stringify({ status: 'visible', time: now }));
				}
			} catch (error) {
				console.warn('Error checking:', url);
			}

			await new Promise(r => setTimeout(r, 250));
		}
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-media"] && !Shopify.designMode) return;
  try {
    // blocks/product-media.liquid
document.addEventListener("DOMContentLoaded", () => {
    function _getModalElements() {
        let modal = document.getElementById("modal");
        let modalContent = document.getElementById("modal_content");
        let modalClose = document.getElementById("modal_close");

        if (!modal) {
            // Modal doesn't exist, create it
            modal = document.createElement("dialog");
            modal.id = "modal";
            modal.setAttribute("aria-label", "Media viewer");
            modal.tabIndex = -1;
            modal.style.setProperty("--width", "100vw");

            modalContent = document.createElement("div");
            modalContent.id = "modal_content";

            modalClose = document.createElement("button");
            modalClose.id = "modal_close";
            modalClose.innerHTML = '<i class="fa-solid fa-xmark"></i>';
            modalClose.setAttribute("aria-label", "Close modal");

            modal.appendChild(modalClose);
            modal.appendChild(modalContent);

            document.body.appendChild(modal);

            // Runs once, regardless of how the dialog closed (X button, native Escape, or .close())
            modal.addEventListener("close", () => {
                modal.classList.remove("is_sliding");
                document.removeEventListener("keydown", handleKeydown);
                document.body.classList.remove("modal_open");
                modalContent.innerHTML = "";
            });
        }
        return {
            modal: modal,
            content: modalContent,
            close: modalClose,
        };
    }

    // Centralized Close Function
    function closeMediaModal(modalElement) {
        if (!modalElement || !modalElement.open) {
            return;
        }

        modalElement.close();
    }

    // Open Modal
    function openMediaModal(state) {
        const { modal, content, close } = _getModalElements();

        const closeHandler = () => {
            closeMediaModal(modal);
        };
        close.onclick = closeHandler;

        document.addEventListener("keydown", (e) => handleKeydown(e, state, content));
        handleTouchEvents(modal, state, content);
        document.body.classList.add("modal_open");

        if (!modal.open) {
            modal.showModal();
        }

        // Force a synchronous layout so the browser commits the closed/off-screen
        // state before we flip to open — see sections/popup-slide.liquid for why.
        void modal.offsetHeight;

        requestAnimationFrame(() => {
            modal.classList.add("is_sliding");
        });

        return content;
    }

    // Render Media (also controls navigation buttons visibility)
    function renderMedia(container, state) {
        const wrapper = container;
        wrapper.innerHTML = "";
        const sourceElement = state.mediaList[state.mediaIndex];

        let videoSource = null;
        let imageSource = null;
        let modelViewer = null;
        let iframeSource = null;
        let newElement = null;

        const tag = sourceElement.tagName.toLowerCase();

        if (tag === "video") {
            videoSource = sourceElement.querySelector("source[data-src]");
        } else if (tag === "img") {
            imageSource = sourceElement;
        } else {
            imageSource = sourceElement.querySelector("img[data-src], img[src]");
            modelViewer = sourceElement.querySelector("model-viewer");
            iframeSource = sourceElement.querySelector("iframe");
        }

        if (videoSource) {
            const video = document.createElement("video");
            video.classList.add("modal_content", "modal_media");
            video.controls = true;
            video.autoplay = true;
            video.playsInline = true;
            video.setAttribute("aria-label", sourceElement.getAttribute("aria-label") || "Video content");

            const source = document.createElement("source");
            source.src = videoSource.getAttribute("data-src");
            source.type = videoSource.getAttribute("type");
            video.appendChild(source);
            newElement = video;

        } else if (imageSource) {
            const image = document.createElement("img");
            image.classList.add("modal_content", "modal_media");
            image.src = imageSource.getAttribute("data-src") || imageSource.getAttribute("src");
            image.alt = imageSource.getAttribute("alt") || "Image content";
            newElement = image;

        } else if (modelViewer) {
            const modelClone = modelViewer.cloneNode(true);
            modelClone.classList.add("modal_content", "modal_media");
            modelClone.setAttribute("aria-label", modelViewer.getAttribute("aria-label") || "3D model viewer");
            newElement = modelClone;

        } else if (iframeSource) {
            const iframeClone = iframeSource.cloneNode(true);
            iframeClone.classList.add("modal_content", "modal_media");
            newElement = iframeClone;
        }
        
        if (newElement) {
            wrapper.appendChild(newElement);
        }
        
        // --- Navigation Buttons (Conditional Visibility) ---
        if (state.mediaList.length > 1) {
            const modalPrev = document.createElement("button");
            modalPrev.id = "modal_prev";
            modalPrev.innerHTML = '<i class="fa-solid fa-chevron-left"></i>';
            modalPrev.setAttribute("aria-label", "Previous media");
            modalPrev.onclick = () => {
                state.mediaIndex = (state.mediaIndex - 1 + state.mediaList.length) % state.mediaList.length;
                renderMedia(wrapper, state);
            };

            const modalNext = document.createElement("button");
            modalNext.id = "modal_next";
            modalNext.innerHTML = '<i class="fa-solid fa-chevron-right"></i>';
            modalNext.setAttribute("aria-label", "Next media");
            modalNext.onclick = () => {
                state.mediaIndex = (state.mediaIndex + 1) % state.mediaList.length;
                renderMedia(wrapper, state);
            };

            wrapper.appendChild(modalPrev);
            wrapper.appendChild(modalNext);
        }
        // ------------------------------------------------------

        preloadAdjacentMedia(state);
    }

    // Preload Adjacent Media
    function preloadAdjacentMedia(state) {
        const preload = (idx) => {
            const element = state.mediaList[idx];
            if (!element) return;

            let videoSource = null;
            let imageSource = null;

            if (element.tagName.toLowerCase() === "video") {
                videoSource = element.querySelector("source[data-src]");
            } else if (element.tagName.toLowerCase() === "img") {
                imageSource = element;
            } else {
                imageSource = element.querySelector("img[data-src]");
            }

            if (videoSource) {
                const link = document.createElement("link");
                link.rel = "preload";
                link.as = "video";
                link.href = videoSource.getAttribute("data-src");
                document.head.appendChild(link);
            } else if (imageSource) {
                const image = new Image();
                image.src = imageSource.getAttribute("data-src");
            }
        };

        preload((state.mediaIndex + 1) % state.mediaList.length);
        preload((state.mediaIndex - 1 + state.mediaList.length) % state.mediaList.length);
    }

    // Handle Keydown Events
    function handleKeydown(event, state, container) {
        const modal = document.getElementById("modal");
        if (!modal) return;

        if (state.mediaList.length > 1) {
            if (event.key === "ArrowLeft") {
                state.mediaIndex = (state.mediaIndex - 1 + state.mediaList.length) % state.mediaList.length;
                renderMedia(container, state);
            } else if (event.key === "ArrowRight") {
                state.mediaIndex = (state.mediaIndex + 1) % state.mediaList.length;
                renderMedia(container, state);
            }
        }
    }

    // Handle Touch Events for Swiping
    function handleTouchEvents(modalElement, state, container) {
        let touchStart = 0;

        modalElement.addEventListener("touchstart", (event) => {
            touchStart = event.touches[0].clientX;
        });

        modalElement.addEventListener("touchend", (event) => {
            if (state.mediaList.length <= 1) return; 

            const touchEnd = event.changedTouches[0].clientX;
            const diff = touchStart - touchEnd;
            const SWIPE_THRESHOLD = 50;

            if (Math.abs(diff) > SWIPE_THRESHOLD) {
                if (diff > 0) { // Swipe Left (Next)
                    state.mediaIndex = (state.mediaIndex + 1) % state.mediaList.length;
                } else { // Swipe Right (Previous)
                    state.mediaIndex = (state.mediaIndex - 1 + state.mediaList.length) % state.mediaList.length;
                }
                renderMedia(container, state);
            }
        });
    }

    // Initializer for Media Block Clicks
    document.querySelectorAll(".block_product_media .action_modal, .block_product_media .action_select").forEach(link => {
        link.addEventListener("click", (event) => {
            const mediaBlock = link.closest(".block_product_media");

            if (link.classList.contains("action_select")) {
                const mediaId = parseInt(mediaBlock.dataset.mediaId);
                const productId = parseInt(mediaBlock.dataset.productId);
                const mediaSelectEvent = new CustomEvent("mediaSelected", {
                    detail: { mediaId, productId, originalEvent: event }
                });
                return document.dispatchEvent(mediaSelectEvent);
            }

            const productId = mediaBlock.dataset.productId;

            let mediaState = {
                mediaList: [],
                mediaIndex: 0,
                productId: productId
            };

            mediaState.mediaList = Array.from(document.querySelectorAll(`.block_product_media[data-product-id="${productId}"] .modal_content`));
            const currentMedia = mediaBlock.querySelector(".modal_content");

            if (mediaState.mediaList.length > 0) {
                mediaState.mediaIndex = mediaState.mediaList.indexOf(currentMedia);
                if (mediaState.mediaIndex === -1) {
                    mediaState.mediaIndex = 0;
                }
            }

            if (mediaState.mediaList.length > 0 && mediaState.mediaList[mediaState.mediaIndex]) {
                const contentWrapper = openMediaModal(mediaState);
                renderMedia(contentWrapper, mediaState);

                const modal = document.getElementById("modal");
                setTimeout(() => {
                    modal.classList.add("is_sliding");
                }, 100);
            }
        });
    });

    // Handle On-Load Active Media
    setTimeout(() => {
        document.querySelectorAll('.block_product_media[data-active-on-load]').forEach(block => {
            const mediaId = parseInt(block.dataset.mediaId);
            const productId = parseInt(block.dataset.productId);
            if (mediaId && productId) {
                const onLoadEvent = new CustomEvent("mediaSelected", {
                    detail: { mediaId, productId }
                });
                document.dispatchEvent(onLoadEvent);
            }
        });
    }, 1);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    // blocks/product-recommendations.liquid
	(function() {
		const elements = document.querySelectorAll('.product_recommendations[data-url]');

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					return;
				}

				const element = entry.target;
				const url = element.dataset.url;
				const carouselElement = element.closest('.block_carousel');

				fetch(url)
					.then(response => response.text())
					.then(html => {
						const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
						const fetchedRecommendations = parsedDoc.querySelector('.product_recommendations');

						if (fetchedRecommendations && fetchedRecommendations.children.length > 0) {
							const hiddenClass = fetchedRecommendations.dataset.hiddenClass;

							if (hiddenClass) {
								document.querySelectorAll('.' + hiddenClass).forEach(el => el.classList.add('active'));
							}

							element.outerHTML = fetchedRecommendations.innerHTML;
							document.dispatchEvent(new CustomEvent('recommendationsLoaded', { detail: { carouselElement } }));
						}
					})
					.catch(error => console.error('Error loading recommendations:', error));

				obs.unobserve(element);
			});
		}, { rootMargin: '0px 0px 400px 0px' });

		elements.forEach(el => observer.observe(el));
	})();

	document.addEventListener('recommendationsLoaded', e => {
		const carouselElement = e.detail.carouselElement;

		if (!carouselElement || !window.CustomCarousel) {
			return;
		}

		if (carouselElement._carouselInstance) {
			if (carouselElement._carouselInstance.observer) {
				carouselElement._carouselInstance.observer.disconnect();
			}

			carouselElement._carouselInstance.stopAutoplay();
		}

		carouselElement._carouselInstance = new CustomCarousel(carouselElement);
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["search"] && !Shopify.designMode) return;
  try {
    // blocks/search.liquid
(function() {

	let debounceTimer;

	function trackEvent(eventName, params) {
		if (typeof trackAnalyticsEvent === 'function') {
			trackAnalyticsEvent(eventName, params);
		} else if (typeof gtag === 'function') {
			gtag('event', eventName, params);
		}
	}

	function setSearchState(searchBlock, stateName) {
		searchBlock.querySelectorAll('.block_search_state.active').forEach(el => el.classList.remove('active'));
		searchBlock.querySelectorAll(`.block_search_state.${stateName}`).forEach(el => el.classList.add('active'));
	}

	function performSearch(searchBlock, query) {
		const queryInput = searchBlock.querySelector('input.search_query');
		const resultsContainer = searchBlock.querySelector('.block_search_results');
		const preSearchBtn = searchBlock.querySelector('.query_btn.pre_search');
		const clearBtn = searchBlock.querySelector('.query_btn.clear_search');
		const loader = searchBlock.querySelector('.query_loader');
		const searchUrl = searchBlock.getAttribute('data-url');

		if (!queryInput || !resultsContainer || !searchUrl) {
			return;
		}

		if (loader) {
			loader.classList.remove('hidden');
		}

		if (preSearchBtn) {
			preSearchBtn.classList.add('hidden');
		}

		if (clearBtn) {
			clearBtn.classList.add('hidden');
		}

		const url = new URL(searchUrl, window.location.origin);
		url.searchParams.set('q', query);

		fetch(url)
			.then(res => res.ok ? res.json() : Promise.reject())
			.then(data => {
				const results = data.resources.results;
				const queries = results.queries || [];
				const groupOrder = ['products', 'collections', 'pages', 'articles'];
				const resultGroups = groupOrder.filter(key => key in results);
				let hasResults = false;

				resultsContainer.innerHTML = '';

				if (queries.length > 0) {
					const queriesDiv = document.createElement('div');
					queriesDiv.className = 'queries';

					queries.forEach(suggestion => {
						if (suggestion.text.toLowerCase() !== query.toLowerCase()) {
							const btn = document.createElement('button');
							btn.type = 'button';
							btn.className = 'query-btn';
							btn.textContent = suggestion.text;
							queriesDiv.appendChild(btn);
						}
					});

					if (queriesDiv.children.length > 0) {
						resultsContainer.appendChild(queriesDiv);
					}
				}

				resultGroups.forEach(groupKey => {
					const items = results[groupKey];

					if (!items || items.length === 0) {
						return;
					}

					hasResults = true;

					let groupHtml = `<div class="group ${groupKey}"><h3 class="result_heading">${groupKey.charAt(0).toUpperCase() + groupKey.slice(1)}</h3>`;

					items.forEach(item => {
						let itemHtml = `<a href="${item.url}" class="result_item" data-query="${query}" data-title="${item.title}">`;

						if (item.featured_image?.url) {
							itemHtml += `<div class="result_img"><img src="${item.featured_image.url}&width=200" alt="${item.title}" loading="lazy"></div>`;
						}

						itemHtml += `<div class="content"><div>${item.title}</div>`;

						if (item.price_min) {
							itemHtml += `<div class="price">${item.price_min !== item.price_max ? `$${item.price_min} - $${item.price_max}` : `$${item.price_min}`}</div>`;
						}

						itemHtml += '</div></a>';
						groupHtml += itemHtml;
					});

					groupHtml += '</div>';
					resultsContainer.innerHTML += groupHtml;
				});

				setSearchState(searchBlock, hasResults || queries.length > 0 ? 'results_found' : 'no_results');
			})
			.catch(() => {
				setSearchState(searchBlock, 'no_results');
				resultsContainer.innerHTML = 'References reset';
			})
			.finally(() => {
				if (loader) {
					loader.classList.add('hidden');
				}

				if (clearBtn) {
					clearBtn.classList.toggle('hidden', queryInput.value.trim().length === 0);
				}

				if (preSearchBtn) {
					preSearchBtn.classList.toggle('hidden', queryInput.value.trim().length > 0);
				}
			});
	}

	document.addEventListener('input', event => {
		const input = event.target.closest('.block_search input.search_query');

		if (!input) {
			return;
		}

		const searchBlock = input.closest('.block_search');
		const query = input.value.trim();
		const preSearchBtn = searchBlock.querySelector('.query_btn.pre_search');
		const clearBtn = searchBlock.querySelector('.query_btn.clear_search');
		const loader = searchBlock.querySelector('.query_loader');
		const resultsContainer = searchBlock.querySelector('.block_search_results');
		const isEmpty = query.length === 0;

		if (loader) {
			loader.classList.add('hidden');
		}

		if (preSearchBtn) {
			preSearchBtn.classList.toggle('hidden', !isEmpty);
		}

		if (clearBtn) {
			clearBtn.classList.toggle('hidden', isEmpty);
		}

		clearTimeout(debounceTimer);

		if (query.length < 2) {
			setSearchState(searchBlock, 'pre_search');

			if (resultsContainer) {
				resultsContainer.innerHTML = '';
			}

			return;
		}

		debounceTimer = setTimeout(() => {
			trackEvent('search', { search_term: query, search_type: 'manual' });
			performSearch(searchBlock, query);
		}, 400);
	});

	document.addEventListener('click', event => {
		const searchBlock = event.target.closest('.block_search');

		if (!searchBlock) {
			return;
		}

		if (event.target.closest('.query_btn.clear_search')) {
			const input = searchBlock.querySelector('input.search_query');

			if (input) {
				input.value = '';
				input.focus();
				input.dispatchEvent(new Event('input', { bubbles: true }));
			}

			return;
		}

		const suggestionBtn = event.target.closest('.query-btn');

		if (suggestionBtn) {
			const input = searchBlock.querySelector('input.search_query');

			if (input) {
				input.value = suggestionBtn.textContent;
				trackEvent('search', { search_term: input.value, search_type: 'suggestion' });
				performSearch(searchBlock, input.value);
			}

			return;
		}

		const resultItem = event.target.closest('.result_item');

		if (resultItem) {
			trackEvent('select_content', { content_type: 'search_result', item_id: resultItem.getAttribute('data-title'), search_term: resultItem.getAttribute('data-query') });
		}
	});

})();
  } catch(e) { console.error(e); }
})();

})();
